var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 1024,
    viewBox: "0 0 612 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4497_42510)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 991.876L19.3403 991.883V1013.97L19.3536 1013.98L38.6805 1002.93V1002.92L19.3551 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 969.773L19.3403 969.78V991.868L19.3536 991.876L38.6805 980.831V980.817L19.3551 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 947.67L19.3403 947.677V969.765L19.3536 969.773L38.6805 958.729V958.714L19.3551 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 925.567L19.3403 925.574V947.662L19.3536 947.67L38.6805 936.625V936.611L19.3551 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 903.464L19.3403 903.471V925.559L19.3536 925.567L38.6805 914.522V914.508L19.3551 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 881.36L19.3403 881.367V903.455L19.3536 903.463L38.6805 892.418V892.404L19.3551 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 859.257L19.3403 859.264V881.352L19.3536 881.36L38.6805 870.315V870.301L19.3551 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 837.154L19.3403 837.161V859.249L19.3536 859.257L38.6805 848.212V848.198L19.3551 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 815.051L19.3403 815.058V837.146L19.3536 837.154L38.6805 826.109V826.095L19.3551 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 792.948L19.3403 792.955V815.043L19.3536 815.051L38.6805 804.006V803.992L19.3551 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 527.711L19.3403 527.719V549.807L19.3536 549.815L38.6805 538.77V538.756L19.3551 527.711Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 483.505L19.3403 483.513V505.601L19.3536 505.608L38.6805 494.564V494.55L19.3551 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 461.401L19.3403 461.409V483.497L19.3536 483.505L38.6805 472.46V472.446L19.3551 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 439.298L19.3403 439.306V461.394L19.3536 461.402L38.6805 450.357V450.343L19.3551 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 417.195L19.3403 417.203V439.291L19.3536 439.299L38.6805 428.254V428.24L19.3551 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 395.092L19.3403 395.1V417.188L19.3536 417.196L38.6805 406.151V406.137L19.3551 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 372.989L19.3403 372.997V395.085L19.3536 395.092L38.6805 384.048V384.034L19.3551 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 350.886L19.3403 350.894V372.982L19.3536 372.99L38.6805 361.945V361.931L19.3551 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 328.783L19.3403 328.791V350.879L19.3536 350.886L38.6805 339.842V339.828L19.3551 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 306.68L19.3403 306.688V328.776L19.3536 328.783L38.6805 317.739V317.725L19.3551 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 284.577L19.3403 284.585V306.673L19.3536 306.68L38.6805 295.636V295.622L19.3551 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 262.473L19.3403 262.481V284.569L19.3536 284.576L38.6805 273.532V273.518L19.3551 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3551 240.37L19.3403 240.378V262.466L19.3536 262.473L38.6805 251.429V251.415L19.3551 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 1002.93V980.824L19.3403 991.876L38.6805 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 980.824V958.721L19.3403 969.773L38.6805 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 958.721V936.618L19.3403 947.67L38.6805 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 936.618V914.515L19.3403 925.567L38.6805 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 914.514V892.411L19.3403 903.463L38.6805 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 892.412V870.309L19.3403 881.361L38.6805 892.412Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 870.309V848.206L19.3403 859.258L38.6805 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 848.206V826.103L19.3403 837.155L38.6805 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 826.103V804L19.3403 815.052L38.6805 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 804V781.897L19.3403 792.949L38.6805 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 494.556V472.453L19.3403 483.505L38.6805 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 472.453V450.35L19.3403 461.402L38.6805 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 450.35V428.247L19.3403 439.299L38.6805 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 428.247V406.144L19.3403 417.196L38.6805 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 406.144V384.041L19.3403 395.093L38.6805 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 384.041V361.938L19.3403 372.99L38.6805 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 361.938V339.835L19.3403 350.887L38.6805 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 339.835V317.732L19.3403 328.784L38.6805 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 317.732V295.629L19.3403 306.681L38.6805 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 295.629V273.526L19.3403 284.578L38.6805 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 273.525V251.422L19.3403 262.474L38.6805 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6805 251.422V229.319L19.3403 240.372L38.6805 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 991.876L174.062 991.883V1013.97L174.049 1013.98L154.722 1002.93V1002.92L174.047 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 969.773L174.062 969.78V991.868L174.049 991.876L154.722 980.831V980.817L174.047 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 947.67L174.062 947.677V969.765L174.049 969.773L154.722 958.729V958.714L174.047 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 925.567L174.062 925.574V947.662L174.049 947.67L154.722 936.625V936.611L174.047 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 903.464L174.062 903.471V925.559L174.049 925.567L154.722 914.522V914.508L174.047 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 881.36L174.062 881.367V903.455L174.049 903.463L154.722 892.418V892.404L174.047 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 859.257L174.062 859.264V881.352L174.049 881.36L154.722 870.315V870.301L174.047 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 837.154L174.062 837.161V859.249L174.049 859.257L154.722 848.212V848.198L174.047 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 815.051L174.062 815.058V837.146L174.049 837.154L154.722 826.109V826.095L174.047 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 792.948L174.062 792.955V815.043L174.049 815.051L154.722 804.006V803.992L174.047 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 770.845L174.062 770.853V792.941L174.049 792.949L154.722 781.904V781.89L174.047 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 748.742L174.062 748.75V770.838L174.049 770.846L154.722 759.801V759.787L174.047 748.742Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 726.64L174.062 726.647V748.735L174.049 748.743L154.722 737.698V737.684L174.047 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 704.536L174.062 704.544V726.632L174.049 726.64L154.722 715.595V715.581L174.047 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 483.505L174.062 483.513V505.601L174.049 505.608L154.722 494.564V494.55L174.047 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 461.401L174.062 461.409V483.497L174.049 483.505L154.722 472.46V472.446L174.047 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 439.298L174.062 439.306V461.394L174.049 461.402L154.722 450.357V450.343L174.047 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 571.917L174.062 571.925V594.013L174.049 594.021L154.722 582.976V582.962L174.047 571.917Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 417.195L174.062 417.203V439.291L174.049 439.299L154.722 428.254V428.24L174.047 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 395.092L174.062 395.1V417.188L174.049 417.196L154.722 406.151V406.137L174.047 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 372.989L174.062 372.997V395.085L174.049 395.092L154.722 384.048V384.034L174.047 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 350.886L174.062 350.894V372.982L174.049 372.99L154.722 361.945V361.931L174.047 350.886Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 328.783L174.062 328.791V350.879L174.049 350.886L154.722 339.842V339.828L174.047 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 306.68L174.062 306.688V328.776L174.049 328.783L154.722 317.739V317.725L174.047 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 284.577L174.062 284.585V306.673L174.049 306.68L154.722 295.636V295.622L174.047 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 262.473L174.062 262.481V284.569L174.049 284.576L154.722 273.532V273.518L174.047 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.047 240.37L174.062 240.378V262.466L174.049 262.473L154.722 251.429V251.415L174.047 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 1002.93V980.824L174.062 991.876L154.722 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 980.824V958.721L174.062 969.773L154.722 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 958.721V936.618L174.062 947.67L154.722 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 936.618V914.515L174.062 925.567L154.722 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 914.514V892.411L174.062 903.463L154.722 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 892.412V870.309L174.062 881.361L154.722 892.412Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 870.309V848.206L174.062 859.258L154.722 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 848.206V826.103L174.062 837.155L154.722 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 826.103V804L174.062 815.052L154.722 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 804V781.897L174.062 792.949L154.722 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 781.897V759.794L174.062 770.846L154.722 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 759.794V737.691L174.062 748.743L154.722 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 737.691V715.588L174.062 726.64L154.722 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 516.66V494.557L174.062 505.609L154.722 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 494.556V472.453L174.062 483.505L154.722 494.556Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 472.453V450.35L174.062 461.402L154.722 472.453Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 450.35V428.247L174.062 439.299L154.722 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 428.247V406.144L174.062 417.196L154.722 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 406.144V384.041L174.062 395.093L154.722 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 384.041V361.938L174.062 372.99L154.722 384.041Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 361.938V339.835L174.062 350.887L154.722 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 339.835V317.732L174.062 328.784L154.722 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 317.732V295.629L174.062 306.681L154.722 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 295.629V273.526L174.062 284.578L154.722 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 273.525V251.422L174.062 262.474L154.722 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 251.422V229.319L174.062 240.371L154.722 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 991.876L212.743 991.883V1013.97L212.756 1013.98L232.083 1002.93V1002.92L212.757 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 969.773L212.743 969.78V991.868L212.756 991.876L232.083 980.831V980.817L212.757 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 947.67L212.743 947.677V969.765L212.756 969.773L232.083 958.729V958.714L212.757 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 925.567L212.743 925.574V947.662L212.756 947.67L232.083 936.625V936.611L212.757 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 903.464L212.743 903.471V925.559L212.756 925.567L232.083 914.522V914.508L212.757 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 881.36L212.743 881.367V903.455L212.756 903.463L232.083 892.418V892.404L212.757 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 859.257L212.743 859.264V881.352L212.756 881.36L232.083 870.315V870.301L212.757 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 837.154L212.743 837.161V859.249L212.756 859.257L232.083 848.212V848.198L212.757 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 815.051L212.743 815.058V837.146L212.756 837.154L232.083 826.109V826.095L212.757 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 792.948L212.743 792.955V815.043L212.756 815.051L232.083 804.006V803.992L212.757 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 770.845L212.743 770.853V792.941L212.756 792.949L232.083 781.904V781.89L212.757 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 748.742L212.743 748.75V770.838L212.756 770.846L232.083 759.801V759.787L212.757 748.742Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 726.64L212.743 726.647V748.735L212.756 748.743L232.083 737.698V737.684L212.757 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 704.536L212.743 704.544V726.632L212.756 726.64L232.083 715.595V715.581L212.757 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 682.432L212.743 682.44V704.528L212.756 704.536L232.083 693.491V693.477L212.757 682.432Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 660.329L212.743 660.337V682.425L212.756 682.433L232.083 671.388V671.374L212.757 660.329Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 483.505L212.743 483.513V505.601L212.756 505.608L232.083 494.564V494.55L212.757 483.505Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 461.401L212.743 461.409V483.497L212.756 483.505L232.083 472.46V472.446L212.757 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 439.298L212.743 439.306V461.394L212.756 461.402L232.083 450.357V450.343L212.757 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 417.195L212.743 417.203V439.291L212.756 439.299L232.083 428.254V428.24L212.757 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 395.092L212.743 395.1V417.188L212.756 417.196L232.083 406.151V406.137L212.757 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 372.989L212.743 372.997V395.085L212.756 395.092L232.083 384.048V384.034L212.757 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 350.886L212.743 350.894V372.982L212.756 372.99L232.083 361.945V361.931L212.757 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 328.783L212.743 328.791V350.879L212.756 350.886L232.083 339.842V339.828L212.757 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 306.68L212.743 306.688V328.776L212.756 328.783L232.083 317.739V317.725L212.757 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 284.577L212.743 284.585V306.673L212.756 306.68L232.083 295.636V295.622L212.757 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 262.473L212.743 262.481V284.569L212.756 284.576L232.083 273.532V273.518L212.757 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.757 240.37L212.743 240.378V262.466L212.756 262.473L232.083 251.429V251.415L212.757 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 1002.93V980.824L212.743 991.876L232.083 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 980.824V958.721L212.743 969.773L232.083 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 958.721V936.618L212.743 947.67L232.083 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 936.618V914.515L212.743 925.567L232.083 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 914.514V892.411L212.743 903.463L232.083 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 892.412V870.309L212.743 881.361L232.083 892.412Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 870.309V848.206L212.743 859.258L232.083 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 848.206V826.103L212.743 837.155L232.083 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 826.103V804L212.743 815.052L232.083 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 804V781.897L212.743 792.949L232.083 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 781.897V759.794L212.743 770.846L232.083 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 759.794V737.691L212.743 748.743L232.083 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 737.691V715.588L212.743 726.64L232.083 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 715.588V693.485L212.743 704.537L232.083 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 693.484V671.381L212.743 682.433L232.083 693.484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 516.66V494.557L212.743 505.609L232.083 516.66Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 472.453V450.35L212.743 461.402L232.083 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 450.35V428.247L212.743 439.299L232.083 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 428.247V406.144L212.743 417.196L232.083 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 406.144V384.041L212.743 395.093L232.083 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 384.041V361.938L212.743 372.99L232.083 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 361.938V339.835L212.743 350.887L232.083 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 339.835V317.732L212.743 328.784L232.083 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 317.732V295.629L212.743 306.681L232.083 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 295.629V273.526L212.743 284.578L232.083 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 273.525V251.422L212.743 262.474L232.083 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 251.422V229.319L212.743 240.372L232.083 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 947.67L290.104 947.677V969.765L290.09 969.773L270.763 958.729V958.714L290.089 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 925.567L290.104 925.574V947.662L290.09 947.67L270.763 936.625V936.611L290.089 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 903.464L290.104 903.471V925.559L290.09 925.567L270.763 914.522V914.508L290.089 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 881.36L290.104 881.367V903.455L290.09 903.463L270.763 892.418V892.404L290.089 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 859.257L290.104 859.264V881.352L290.09 881.36L270.763 870.315V870.301L290.089 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 837.154L290.104 837.161V859.249L290.09 859.257L270.763 848.212V848.198L290.089 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 815.051L290.104 815.058V837.146L290.09 837.154L270.763 826.109V826.095L290.089 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 792.948L290.104 792.955V815.043L290.09 815.051L270.763 804.006V803.992L290.089 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 770.845L290.104 770.853V792.941L290.09 792.949L270.763 781.904V781.89L290.089 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 748.742L290.104 748.75V770.838L290.09 770.846L270.763 759.801V759.787L290.089 748.742Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 726.64L290.104 726.647V748.735L290.09 748.743L270.763 737.698V737.684L290.089 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 704.536L290.104 704.544V726.632L290.09 726.64L270.763 715.595V715.581L290.089 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 682.432L290.104 682.44V704.528L290.09 704.536L270.763 693.491V693.477L290.089 682.432Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 660.329L290.104 660.337V682.425L290.09 682.433L270.763 671.388V671.374L290.089 660.329Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 638.227L290.104 638.234V660.322L290.09 660.33L270.763 649.285V649.271L290.089 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 616.124L290.104 616.131V638.219L290.09 638.227L270.763 627.182V627.168L290.089 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 594.021L290.104 594.028V616.116L290.09 616.124L270.763 605.079V605.065L290.089 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 571.917L290.104 571.925V594.013L290.09 594.021L270.763 582.976V582.962L290.089 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 549.814L290.104 549.822V571.91L290.09 571.918L270.763 560.873V560.859L290.089 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 527.711L290.104 527.719V549.807L290.09 549.815L270.763 538.77V538.756L290.089 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 505.608L290.104 505.616V527.704L290.09 527.711L270.763 516.667V516.653L290.089 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 483.505L290.104 483.513V505.601L290.09 505.608L270.763 494.564V494.55L290.089 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 461.401L290.104 461.409V483.497L290.09 483.504L270.763 472.46V472.446L290.089 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 439.298L290.104 439.306V461.394L290.09 461.402L270.763 450.357V450.343L290.089 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 417.195L290.104 417.203V439.291L290.09 439.299L270.763 428.254V428.24L290.089 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 395.092L290.104 395.1V417.188L290.09 417.196L270.763 406.151V406.137L290.089 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 372.989L290.104 372.997V395.085L290.09 395.092L270.763 384.048V384.034L290.089 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 350.886L290.104 350.894V372.982L290.09 372.989L270.763 361.945V361.931L290.089 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 328.783L290.104 328.791V350.879L290.09 350.886L270.763 339.842V339.828L290.089 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 306.68L290.104 306.688V328.776L290.09 328.783L270.763 317.739V317.725L290.089 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 284.577L290.104 284.585V306.673L290.09 306.68L270.763 295.636V295.622L290.089 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 262.473L290.104 262.481V284.569L290.09 284.576L270.763 273.532V273.518L290.089 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 240.37L290.104 240.378V262.466L290.09 262.473L270.763 251.429V251.415L290.089 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 218.267L290.104 218.275V240.363L290.09 240.37L270.763 229.326V229.312L290.089 218.267Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.089 196.164L290.104 196.172V218.26L290.09 218.267L270.763 207.223V207.209L290.089 196.164Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 958.721V936.618L290.104 947.67L270.763 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 936.618V914.515L290.104 925.567L270.763 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 914.514V892.411L290.104 903.463L270.763 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 892.412V870.309L290.104 881.361L270.763 892.412Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 870.309V848.206L290.104 859.258L270.763 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 848.206V826.103L290.104 837.155L270.763 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 826.103V804L290.104 815.052L270.763 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 804V781.897L290.104 792.949L270.763 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 781.897V759.794L290.104 770.846L270.763 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 759.794V737.691L290.104 748.743L270.763 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 737.691V715.588L290.104 726.64L270.763 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 715.588V693.485L290.104 704.537L270.763 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 693.484V671.381L290.104 682.433L270.763 693.484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 671.381V649.278L290.104 660.33L270.763 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 649.278V627.175L290.104 638.227L270.763 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 627.175V605.072L290.104 616.124L270.763 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 605.072V582.969L290.104 594.021L270.763 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 582.969V560.866L290.104 571.918L270.763 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 560.866V538.763L290.104 549.815L270.763 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 516.66V494.557L290.104 505.609L270.763 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 472.453V450.35L290.104 461.402L270.763 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 450.35V428.247L290.104 439.299L270.763 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 428.247V406.144L290.104 417.196L270.763 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 406.144V384.041L290.104 395.093L270.763 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 384.041V361.938L290.104 372.99L270.763 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 361.938V339.835L290.104 350.887L270.763 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 339.835V317.732L290.104 328.784L270.763 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 317.732V295.629L290.104 306.681L270.763 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 295.629V273.526L290.104 284.578L270.763 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 273.525V251.422L290.104 262.474L270.763 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 251.422V229.319L290.104 240.371L270.763 251.422Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 229.319V207.216L290.104 218.268L270.763 229.319Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 207.216V185.113L290.104 196.165L270.763 207.216Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 980.824L386.804 980.831V1002.92L386.817 1002.93L406.144 991.883V991.868L386.819 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 958.721L386.804 958.728V980.817L386.817 980.824L406.144 969.78V969.765L386.819 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 936.618L386.804 936.625V958.714L386.817 958.721L406.144 947.677V947.662L386.819 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 914.515L386.804 914.522V936.611L386.817 936.618L406.144 925.574V925.559L386.819 914.515Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 892.411L386.804 892.418V914.507L386.817 914.514L406.144 903.47V903.455L386.819 892.411Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 870.309L386.804 870.316V892.405L386.817 892.412L406.144 881.368V881.353L386.819 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 848.206L386.804 848.213V870.302L386.817 870.309L406.144 859.265V859.25L386.819 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 582.969L386.804 582.976V605.065L386.817 605.072L406.144 594.028V594.013L386.819 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 538.763L386.804 538.77V560.859L386.817 560.866L406.144 549.822V549.807L386.819 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 384.041L386.804 384.048V406.137L386.817 406.144L406.144 395.1V395.085L386.819 384.041Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 737.691L386.804 737.698V759.787L386.817 759.794L406.144 748.75V748.735L386.819 737.691Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 361.938L386.804 361.945V384.034L386.817 384.041L406.144 372.997V372.982L386.819 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 273.526L386.804 273.533V295.622L386.817 295.629L406.144 284.585V284.57L386.819 273.526Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 251.422L386.804 251.429V273.518L386.817 273.525L406.144 262.481V262.466L386.819 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.819 229.319L386.804 229.326V251.415L386.817 251.422L406.144 240.378V240.363L386.819 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 991.876V969.773L386.804 980.825L406.144 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 969.773V947.67L386.804 958.722L406.144 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 947.67V925.567L386.804 936.619L406.144 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 925.567V903.464L386.804 914.516L406.144 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 903.463V881.36L386.804 892.412L406.144 903.463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 881.36V859.257L386.804 870.309L406.144 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 859.257V837.154L386.804 848.206L406.144 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 594.021V571.917L386.804 582.97L406.144 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 571.918V549.814L386.804 560.867L406.144 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 549.815V527.711L386.804 538.764L406.144 549.815Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 638.227V616.124L386.804 627.176L406.144 638.227Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 527.711V505.608L386.804 516.661L406.144 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 505.608V483.505L386.804 494.558L406.144 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 461.402V439.298L386.804 450.351L406.144 461.402Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 439.299V417.195L386.804 428.248L406.144 439.299Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 372.989V350.886L386.804 361.939L406.144 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 328.783V306.68L386.804 317.733L406.144 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 306.68V284.577L386.804 295.63L406.144 306.68Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 284.576V262.473L386.804 273.526L406.144 284.576Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 262.473V240.37L386.804 251.423L406.144 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.144 240.371V218.268L386.804 229.32L406.144 240.371Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 991.876L406.145 991.883V1013.97L406.158 1013.98L425.485 1002.93V1002.92L406.159 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 969.773L406.145 969.78V991.868L406.158 991.876L425.485 980.831V980.817L406.159 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 947.67L406.145 947.677V969.765L406.158 969.773L425.485 958.729V958.714L406.159 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 925.567L406.145 925.574V947.662L406.158 947.67L425.485 936.625V936.611L406.159 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 903.464L406.145 903.471V925.559L406.158 925.567L425.485 914.522V914.508L406.159 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 881.36L406.145 881.367V903.455L406.158 903.463L425.485 892.418V892.404L406.159 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 859.257L406.145 859.264V881.352L406.158 881.36L425.485 870.315V870.301L406.159 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 594.021L406.145 594.028V616.116L406.158 616.124L425.485 605.079V605.065L406.159 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 549.814L406.145 549.822V571.91L406.158 571.918L425.485 560.873V560.859L406.159 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 748.742L406.145 748.75V770.838L406.158 770.846L425.485 759.801V759.787L406.159 748.742Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 372.989L406.145 372.997V395.085L406.158 395.092L425.485 384.048V384.034L406.159 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 284.577L406.145 284.585V306.673L406.158 306.68L425.485 295.636V295.622L406.159 284.577Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 262.473L406.145 262.481V284.569L406.158 284.576L425.485 273.532V273.518L406.159 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.159 240.37L406.145 240.378V262.466L406.158 262.473L425.485 251.429V251.415L406.159 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 1002.93V980.824L406.145 991.876L425.485 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 980.824V958.721L406.145 969.773L425.485 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 958.721V936.618L406.145 947.67L425.485 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 936.618V914.515L406.145 925.567L425.485 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 914.514V892.411L406.145 903.463L425.485 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 892.412V870.309L406.145 881.361L425.485 892.412Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 870.309V848.206L406.145 859.258L425.485 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 605.072V582.969L406.145 594.021L425.485 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 582.969V560.866L406.145 571.918L425.485 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 693.484V671.381L406.145 682.433L425.485 693.484Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 538.763V516.66L406.145 527.712L425.485 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 516.66V494.557L406.145 505.609L425.485 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 472.453V450.35L406.145 461.402L425.485 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 450.35V428.247L406.145 439.299L425.485 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 384.041V361.938L406.145 372.99L425.485 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 339.835V317.732L406.145 328.784L425.485 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 317.732V295.629L406.145 306.681L425.485 317.732Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 295.629V273.526L406.145 284.578L425.485 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 273.525V251.422L406.145 262.474L425.485 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.485 251.422V229.319L406.145 240.372L425.485 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 804L464.165 804.007V826.096L464.152 826.103L444.825 815.059V815.044L464.15 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 781.897L464.165 781.904V803.993L464.152 804L444.825 792.956V792.941L464.15 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 759.794L464.165 759.801V781.89L464.152 781.897L444.825 770.853V770.838L464.15 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 737.691L464.165 737.698V759.787L464.152 759.794L444.825 748.75V748.735L464.15 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 715.588L464.165 715.595V737.684L464.152 737.691L444.825 726.647V726.632L464.15 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 693.485L464.165 693.492V715.581L464.152 715.588L444.825 704.544V704.529L464.15 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 671.381L464.165 671.388V693.477L464.152 693.484L444.825 682.44V682.425L464.15 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 649.278L464.165 649.285V671.374L464.152 671.381L444.825 660.337V660.322L464.15 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 627.175L464.165 627.182V649.271L464.152 649.278L444.825 638.234V638.219L464.15 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 605.072L464.165 605.079V627.168L464.152 627.175L444.825 616.131V616.116L464.15 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 582.969L464.165 582.976V605.065L464.152 605.072L444.825 594.028V594.013L464.15 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 361.938L464.165 361.945V384.034L464.152 384.041L444.825 372.997V372.982L464.15 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 339.835L464.165 339.842V361.931L464.152 361.938L444.825 350.894V350.879L464.15 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 251.422L464.165 251.429V273.518L464.152 273.525L444.825 262.481V262.466L464.15 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 229.319L464.165 229.326V251.415L464.152 251.422L444.825 240.378V240.363L464.15 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 207.216L464.165 207.223V229.312L464.152 229.319L444.825 218.275V218.26L464.15 207.216Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 185.113L464.165 185.12V207.209L464.152 207.216L444.825 196.172V196.157L464.15 185.113Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 118.804L464.165 118.811V140.9L464.152 140.907L444.825 129.863V129.848L464.15 118.804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 96.7008L464.165 96.7081V118.797L464.152 118.804L444.825 107.76V107.745L464.15 96.7008Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 74.5978L464.165 74.6051V96.6936L464.152 96.7009L444.825 85.6566V85.642L464.15 74.5978Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.15 52.4938L464.165 52.5011V74.5896L464.152 74.5969L444.825 63.5527V63.5381L464.15 52.4938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 815.051V792.948L464.165 804L444.825 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 792.949V770.845L464.165 781.898L444.825 792.949Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 770.846V748.742L464.165 759.795L444.825 770.846Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 748.743V726.64L464.165 737.692L444.825 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 726.64V704.536L464.165 715.589L444.825 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 704.536V682.432L464.165 693.485L444.825 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 682.433V660.329L464.165 671.382L444.825 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 660.33V638.227L464.165 649.279L444.825 660.33Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 638.227V616.124L464.165 627.176L444.825 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 616.124V594.021L464.165 605.073L444.825 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 461.402V439.298L464.165 450.351L444.825 461.402Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 395.092V372.989L464.165 384.042L444.825 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 372.989V350.886L464.165 361.939L444.825 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 350.886V328.783L464.165 339.836L444.825 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 284.576V262.473L464.165 273.526L444.825 284.576Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 262.473V240.37L464.165 251.423L444.825 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 240.37V218.267L464.165 229.32L444.825 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 218.267V196.164L464.165 207.217L444.825 218.267Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 196.164V174.061L464.165 185.114L444.825 196.164Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 174.061V151.958L464.165 163.011L444.825 174.061Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 151.958V129.855L464.165 140.908L444.825 151.958Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 129.855V107.752L464.165 118.805L444.825 129.855Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 107.752V85.6493L464.165 96.7016L444.825 107.752Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 85.6494V63.5463L464.165 74.5985L444.825 85.6494Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.825 63.5454V41.4423L464.165 52.4946L444.825 63.5454Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 980.824L502.846 980.831V1002.92L502.832 1002.93L483.505 991.883V991.868L502.831 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 958.721L502.846 958.728V980.817L502.832 980.824L483.505 969.78V969.765L502.831 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 936.618L502.846 936.625V958.714L502.832 958.721L483.505 947.677V947.662L502.831 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 914.515L502.846 914.522V936.611L502.832 936.618L483.505 925.574V925.559L502.831 914.515Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 892.411L502.846 892.418V914.507L502.832 914.514L483.505 903.47V903.455L502.831 892.411Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 870.309L502.846 870.316V892.405L502.832 892.412L483.505 881.368V881.353L502.831 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 848.206L502.846 848.213V870.302L502.832 870.309L483.505 859.265V859.25L502.831 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 826.103L502.846 826.11V848.199L502.832 848.206L483.505 837.162V837.147L502.831 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 804L502.846 804.007V826.096L502.832 826.103L483.505 815.059V815.044L502.831 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 781.897L502.846 781.904V803.993L502.832 804L483.505 792.956V792.941L502.831 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 759.794L502.846 759.801V781.89L502.832 781.897L483.505 770.853V770.838L502.831 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 737.691L502.846 737.698V759.787L502.832 759.794L483.505 748.75V748.735L502.831 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 715.588L502.846 715.595V737.684L502.832 737.691L483.505 726.647V726.632L502.831 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 693.485L502.846 693.492V715.581L502.832 715.588L483.505 704.544V704.529L502.831 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 627.175L502.846 627.182V649.271L502.832 649.278L483.505 638.234V638.219L502.831 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 605.072L502.846 605.079V627.168L502.832 627.175L483.505 616.131V616.116L502.831 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 582.969L502.846 582.976V605.065L502.832 605.072L483.505 594.028V594.013L502.831 582.969Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 538.763L502.846 538.77V560.859L502.832 560.866L483.505 549.822V549.807L502.831 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 516.66L502.846 516.667V538.756L502.832 538.763L483.505 527.719V527.704L502.831 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 428.247L502.846 428.254V450.343L502.832 450.35L483.505 439.306V439.291L502.831 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 406.144L502.846 406.151V428.24L502.832 428.247L483.505 417.203V417.188L502.831 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 361.938L502.846 361.945V384.034L502.832 384.041L483.505 372.997V372.982L502.831 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 317.732L502.846 317.739V339.828L502.832 339.835L483.505 328.791V328.776L502.831 317.732Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 295.629L502.846 295.636V317.725L502.832 317.732L483.505 306.688V306.673L502.831 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 273.526L502.846 273.533V295.622L502.832 295.629L483.505 284.585V284.57L502.831 273.526Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 251.422L502.846 251.429V273.518L502.832 273.525L483.505 262.481V262.466L502.831 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.831 229.319L502.846 229.326V251.415L502.832 251.422L483.505 240.378V240.363L502.831 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 991.876V969.773L502.846 980.825L483.505 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 969.773V947.67L502.846 958.722L483.505 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 947.67V925.567L502.846 936.619L483.505 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 925.567V903.464L502.846 914.516L483.505 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 903.463V881.36L502.846 892.412L483.505 903.463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 881.36V859.257L502.846 870.309L483.505 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 859.257V837.154L502.846 848.206L483.505 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 837.154V815.051L502.846 826.103L483.505 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 815.051V792.948L502.846 804L483.505 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 792.949V770.845L502.846 781.898L483.505 792.949Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 770.846V748.742L502.846 759.795L483.505 770.846Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 748.743V726.64L502.846 737.692L483.505 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 726.64V704.536L502.846 715.589L483.505 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 638.227V616.124L502.846 627.176L483.505 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 571.918V549.814L502.846 560.867L483.505 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 549.815V527.711L502.846 538.764L483.505 549.815Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 527.711V505.608L502.846 516.661L483.505 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 483.505V461.401L502.846 472.454L483.505 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 461.402V439.298L502.846 450.351L483.505 461.402Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 439.299V417.195L502.846 428.248L483.505 439.299Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 417.196V395.092L502.846 406.145L483.505 417.196Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 395.092V372.989L502.846 384.042L483.505 395.092Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 372.989V350.886L502.846 361.939L483.505 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 350.886V328.783L502.846 339.836L483.505 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 328.783V306.68L502.846 317.733L483.505 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 306.68V284.577L502.846 295.63L483.505 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 284.576V262.473L502.846 273.526L483.505 284.576Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 262.473V240.37L502.846 251.423L483.505 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 240.37V218.267L502.846 229.32L483.505 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 748.742L19.3403 748.75V770.838L19.3271 770.846L0.000125885 759.801V759.787L19.3256 748.742Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 726.64L19.3403 726.647V748.735L19.3271 748.743L0.000125885 737.698V737.684L19.3256 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 704.536L19.3403 704.544V726.632L19.3271 726.64L0.000125885 715.595V715.581L19.3256 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 682.432L19.3403 682.44V704.528L19.3271 704.536L0.000125885 693.491V693.477L19.3256 682.432Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 660.329L19.3403 660.337V682.425L19.3271 682.433L0.000125885 671.388V671.374L19.3256 660.329Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 638.227L19.3403 638.234V660.322L19.3271 660.33L0.000125885 649.285V649.271L19.3256 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 616.124L19.3403 616.131V638.219L19.3271 638.227L0.000125885 627.182V627.168L19.3256 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 594.021L19.3403 594.028V616.116L19.3271 616.124L0.000125885 605.079V605.065L19.3256 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 571.917L19.3403 571.925V594.013L19.3271 594.021L0.000125885 582.976V582.962L19.3256 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 549.814L19.3403 549.822V571.91L19.3271 571.918L0.000125885 560.873V560.859L19.3256 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 527.711L19.3403 527.719V549.807L19.3271 549.815L0.000125885 538.77V538.756L19.3256 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 505.608L19.3403 505.616V527.704L19.3271 527.711L0.000125885 516.667V516.653L19.3256 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 483.505L19.3403 483.513V505.601L19.3271 505.608L0.000125885 494.564V494.55L19.3256 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 461.401L19.3403 461.409V483.497L19.3271 483.504L0.000125885 472.46V472.446L19.3256 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 439.298L19.3403 439.306V461.394L19.3271 461.402L0.000125885 450.357V450.343L19.3256 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 417.195L19.3403 417.203V439.291L19.3271 439.299L0.000125885 428.254V428.24L19.3256 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 284.577L19.3403 284.585V306.673L19.3271 306.68L0.000125885 295.636V295.622L19.3256 284.577Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 262.473L19.3403 262.481V284.569L19.3271 284.576L0.000125885 273.532V273.518L19.3256 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 240.37L19.3403 240.378V262.466L19.3271 262.473L0.000125885 251.429V251.415L19.3256 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 218.267L19.3403 218.275V240.363L19.3271 240.37L0.000125885 229.326V229.312L19.3256 218.267Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 196.164L19.3403 196.172V218.26L19.3271 218.267L0.000125885 207.223V207.209L19.3256 196.164Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 174.061L19.3403 174.069V196.157L19.3271 196.164L0.000125885 185.12V185.106L19.3256 174.061Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 151.958L19.3403 151.966V174.054L19.3271 174.061L0.000125885 163.017V163.003L19.3256 151.958Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 129.855L19.3403 129.863V151.951L19.3271 151.958L0.000125885 140.914V140.9L19.3256 129.855Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 107.752L19.3403 107.76V129.848L19.3271 129.855L0.000125885 118.811V118.797L19.3256 107.752Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 85.6493L19.3403 85.6566V107.745L19.3271 107.752L0.000125885 96.7081V96.6935L19.3256 85.6493Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 63.5463L19.3403 63.5536V85.6421L19.3271 85.6494L0.000125885 74.6051V74.5905L19.3256 63.5463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 41.4423L19.3403 41.4496V63.5381L19.3271 63.5454L0.000125885 52.5012V52.4866L19.3256 41.4423Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 19.3393L19.3403 19.3466V41.4351L19.3271 41.4424L0.000125885 30.3981V30.3835L19.3256 19.3393Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3256 -2.76373L19.3403 -2.75644V19.3321L19.3271 19.3394L0.000125885 8.29511V8.28052L19.3256 -2.76373Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 759.794V737.691L19.3403 748.743L0.000125885 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 737.691V715.588L19.3403 726.64L0.000125885 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 715.588V693.485L19.3403 704.537L0.000125885 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 693.484V671.381L19.3403 682.433L0.000125885 693.484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 671.381V649.278L19.3403 660.33L0.000125885 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 649.278V627.175L19.3403 638.227L0.000125885 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 627.175V605.072L19.3403 616.124L0.000125885 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 605.072V582.969L19.3403 594.021L0.000125885 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 582.969V560.866L19.3403 571.918L0.000125885 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 560.866V538.763L19.3403 549.815L0.000125885 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 538.763V516.66L19.3403 527.712L0.000125885 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 516.66V494.557L19.3403 505.609L0.000125885 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 494.556V472.453L19.3403 483.505L0.000125885 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 472.453V450.35L19.3403 461.402L0.000125885 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 450.35V428.247L19.3403 439.299L0.000125885 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 428.247V406.144L19.3403 417.196L0.000125885 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 295.629V273.526L19.3403 284.578L0.000125885 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 273.525V251.422L19.3403 262.474L0.000125885 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 251.422V229.319L19.3403 240.371L0.000125885 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 229.319V207.216L19.3403 218.268L0.000125885 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 207.216V185.113L19.3403 196.165L0.000125885 207.216Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 185.113V163.01L19.3403 174.062L0.000125885 185.113Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 163.01V140.907L19.3403 151.959L0.000125885 163.01Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 140.907V118.804L19.3403 129.856L0.000125885 140.907Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 118.804V96.7008L19.3403 107.753L0.000125885 118.804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 96.7009V74.5978L19.3403 85.6501L0.000125885 96.7009Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 74.5969V52.4938L19.3403 63.5461L0.000125885 74.5969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 52.4939V30.3908L19.3403 41.4431L0.000125885 52.4939Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 30.3909V8.28778L19.3403 19.3401L0.000125885 30.3909Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000125885 8.28785V-13.8152L19.3403 -2.76297L0.000125885 8.28785Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 594.021L58.0205 594.028V616.116L58.0338 616.124L77.3607 605.079V605.065L58.0352 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 571.917L58.0205 571.925V594.013L58.0338 594.021L77.3607 582.976V582.962L58.0352 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 549.814L58.0205 549.822V571.91L58.0338 571.918L77.3607 560.873V560.859L58.0352 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 527.711L58.0205 527.719V549.807L58.0338 549.815L77.3607 538.77V538.756L58.0352 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 505.608L58.0205 505.616V527.704L58.0338 527.711L77.3607 516.667V516.653L58.0352 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 483.505L58.0205 483.513V505.601L58.0338 505.608L77.3607 494.564V494.55L58.0352 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 461.401L58.0205 461.409V483.497L58.0338 483.504L77.3607 472.46V472.446L58.0352 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 439.298L58.0205 439.306V461.394L58.0338 461.401L77.3607 450.357V450.343L58.0352 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 417.195L58.0205 417.203V439.291L58.0338 439.299L77.3607 428.254V428.24L58.0352 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 395.092L58.0205 395.1V417.188L58.0338 417.196L77.3607 406.151V406.137L58.0352 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 328.783L58.0205 328.791V350.879L58.0338 350.886L77.3607 339.842V339.828L58.0352 328.783Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 63.5463L58.0205 63.5536V85.6421L58.0338 85.6494L77.3607 74.6051V74.5905L58.0352 63.5463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 41.4423L58.0205 41.4496V63.5381L58.0338 63.5454L77.3607 52.5012V52.4866L58.0352 41.4423Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 19.3393L58.0205 19.3466V41.4351L58.0338 41.4424L77.3607 30.3981V30.3835L58.0352 19.3393Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0352 -2.76373L58.0205 -2.75644V19.3321L58.0338 19.3394L77.3607 8.29511V8.28052L58.0352 -2.76373Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 605.072V582.969L58.0205 594.021L77.3607 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 582.969V560.866L58.0205 571.918L77.3607 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 560.866V538.763L58.0205 549.815L77.3607 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 538.763V516.66L58.0205 527.712L77.3607 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 516.66V494.557L58.0205 505.609L77.3607 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 494.556V472.453L58.0205 483.505L77.3607 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 472.453V450.35L58.0205 461.402L77.3607 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 450.35V428.247L58.0205 439.299L77.3607 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 428.247V406.144L58.0205 417.196L77.3607 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 406.144V384.041L58.0205 395.093L77.3607 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 96.7009V74.5978L58.0205 85.6501L77.3607 96.7009Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 74.5969V52.4938L58.0205 63.5461L77.3607 74.5969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 52.4939V30.3908L58.0205 41.4431L77.3607 52.4939Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 30.3909V8.28778L58.0205 19.3401L77.3607 30.3909Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3607 8.28791V-13.8152L58.0205 -2.76291L77.3607 8.28791Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 1013.98L96.7017 1013.99V1036.07L96.6884 1036.08L77.3615 1025.04V1025.02L96.6869 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 991.876L96.7017 991.883V1013.97L96.6884 1013.98L77.3615 1002.93V1002.92L96.6869 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 969.773L96.7017 969.78V991.868L96.6884 991.876L77.3615 980.831V980.817L96.6869 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 947.67L96.7017 947.677V969.765L96.6884 969.773L77.3615 958.729V958.714L96.6869 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 925.567L96.7017 925.574V947.662L96.6884 947.67L77.3615 936.625V936.611L96.6869 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 903.464L96.7017 903.471V925.559L96.6884 925.567L77.3615 914.522V914.508L96.6869 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 881.36L96.7017 881.367V903.455L96.6884 903.463L77.3615 892.418V892.404L96.6869 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 859.257L96.7017 859.264V881.352L96.6884 881.36L77.3615 870.315V870.301L96.6869 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 837.154L96.7017 837.161V859.249L96.6884 859.257L77.3615 848.212V848.198L96.6869 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 748.743L96.7017 748.75V770.838L96.6884 770.846L77.3615 759.801V759.787L96.6869 748.743Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6868 505.608L96.7015 505.616V527.704L96.6883 527.711L77.3613 516.667V516.653L96.6868 505.608Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 483.505L96.7017 483.513V505.601L96.6884 505.608L77.3615 494.564V494.55L96.6869 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 461.401L96.7017 461.409V483.497L96.6884 483.505L77.3615 472.46V472.446L96.6869 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 439.298L96.7017 439.306V461.394L96.6884 461.402L77.3615 450.357V450.343L96.6869 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 417.195L96.7017 417.203V439.291L96.6884 439.299L77.3615 428.254V428.24L96.6869 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 395.092L96.7017 395.1V417.188L96.6884 417.196L77.3615 406.151V406.137L96.6869 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 372.989L96.7017 372.997V395.085L96.6884 395.092L77.3615 384.048V384.034L96.6869 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 350.886L96.7017 350.894V372.982L96.6884 372.99L77.3615 361.945V361.931L96.6869 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 328.783L96.7017 328.791V350.879L96.6884 350.886L77.3615 339.842V339.828L96.6869 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6869 306.68L96.7017 306.688V328.776L96.6884 328.783L77.3615 317.739V317.725L96.6869 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 1025.03V1002.93L96.7017 1013.98L77.3615 1025.03Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 1002.93V980.824L96.7017 991.876L77.3615 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 980.824V958.721L96.7017 969.773L77.3615 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 958.721V936.618L96.7017 947.67L77.3615 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 936.618V914.515L96.7017 925.567L77.3615 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 914.514V892.411L96.7017 903.463L77.3615 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 892.412V870.309L96.7017 881.361L77.3615 892.412Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 870.309V848.206L96.7017 859.258L77.3615 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 781.897V759.794L96.7017 770.846L77.3615 781.897Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 671.381V649.278L96.7017 660.33L77.3615 671.381Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 516.66V494.557L96.7017 505.609L77.3615 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 494.556V472.453L96.7017 483.505L77.3615 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 472.453V450.35L96.7017 461.402L77.3615 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 450.35V428.247L96.7017 439.299L77.3615 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 428.247V406.144L96.7017 417.196L77.3615 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 406.144V384.041L96.7017 395.093L77.3615 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 384.041V361.938L96.7017 372.99L77.3615 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 361.938V339.835L96.7017 350.887L77.3615 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 339.835V317.732L96.7017 328.784L77.3615 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3615 317.732V295.629L96.7017 306.681L77.3615 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 1013.98L135.382 1013.99V1036.07L135.369 1036.08L116.042 1025.04V1025.02L135.367 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 991.876L135.382 991.883V1013.97L135.369 1013.98L116.042 1002.93V1002.92L135.367 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 969.773L135.382 969.78V991.868L135.369 991.876L116.042 980.831V980.817L135.367 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 947.67L135.382 947.677V969.765L135.369 969.773L116.042 958.729V958.714L135.367 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 925.567L135.382 925.574V947.662L135.369 947.67L116.042 936.625V936.611L135.367 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 903.464L135.382 903.471V925.559L135.369 925.567L116.042 914.522V914.508L135.367 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 881.36L135.382 881.367V903.455L135.369 903.463L116.042 892.418V892.404L135.367 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 859.257L135.382 859.264V881.352L135.369 881.36L116.042 870.315V870.301L135.367 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 837.154L135.382 837.161V859.249L135.369 859.257L116.042 848.212V848.198L135.367 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 815.051L135.382 815.058V837.146L135.369 837.154L116.042 826.109V826.095L135.367 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 792.948L135.382 792.955V815.043L135.369 815.051L116.042 804.006V803.992L135.367 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 770.845L135.382 770.853V792.941L135.369 792.949L116.042 781.904V781.89L135.367 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 638.227L135.382 638.234V660.322L135.369 660.33L116.042 649.285V649.271L135.367 638.227Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 726.64L135.382 726.647V748.735L135.369 748.743L116.042 737.698V737.684L135.367 726.64Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 483.505L135.382 483.513V505.601L135.369 505.608L116.042 494.564V494.55L135.367 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 461.401L135.382 461.409V483.497L135.369 483.505L116.042 472.46V472.446L135.367 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 439.298L135.382 439.306V461.394L135.369 461.402L116.042 450.357V450.343L135.367 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 417.195L135.382 417.203V439.291L135.369 439.299L116.042 428.254V428.24L135.367 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 395.092L135.382 395.1V417.188L135.369 417.196L116.042 406.151V406.137L135.367 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 372.989L135.382 372.997V395.085L135.369 395.092L116.042 384.048V384.034L135.367 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 350.886L135.382 350.894V372.982L135.369 372.99L116.042 361.945V361.931L135.367 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 328.783L135.382 328.791V350.879L135.369 350.886L116.042 339.842V339.828L135.367 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 306.68L135.382 306.688V328.776L135.369 328.783L116.042 317.739V317.725L135.367 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 284.577L135.382 284.585V306.673L135.369 306.68L116.042 295.636V295.622L135.367 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.367 262.473L135.382 262.481V284.569L135.369 284.576L116.042 273.532V273.518L135.367 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 1025.03V1002.93L135.382 1013.98L116.042 1025.03Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 1002.93V980.824L135.382 991.876L116.042 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 980.824V958.721L135.382 969.773L116.042 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 958.721V936.618L135.382 947.67L116.042 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 936.618V914.515L135.382 925.567L116.042 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 914.514V892.411L135.382 903.463L116.042 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 892.412V870.309L135.382 881.361L116.042 892.412Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 870.309V848.206L135.382 859.258L116.042 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 848.206V826.103L135.382 837.155L116.042 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 826.103V804L135.382 815.052L116.042 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 804V781.897L135.382 792.949L116.042 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 494.556V472.453L135.382 483.505L116.042 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 472.453V450.35L135.382 461.402L116.042 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 450.35V428.247L135.382 439.299L116.042 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 428.247V406.144L135.382 417.196L116.042 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 406.144V384.041L135.382 395.093L116.042 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 384.041V361.938L135.382 372.99L116.042 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 361.938V339.835L135.382 350.887L116.042 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 339.835V317.732L135.382 328.784L116.042 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 317.732V295.629L135.382 306.681L116.042 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 295.629V273.526L135.382 284.578L116.042 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 273.525V251.422L135.382 262.474L116.042 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 815.051L96.7017 815.058V837.146L96.7149 837.154L116.042 826.109V826.095L96.7164 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 792.948L96.7017 792.955V815.043L96.7149 815.051L116.042 804.006V803.992L96.7164 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 770.845L96.7017 770.853V792.941L96.7149 792.949L116.042 781.904V781.89L96.7164 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 748.742L96.7017 748.75V770.838L96.7149 770.846L116.042 759.801V759.787L96.7164 748.742Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 726.64L96.7017 726.647V748.735L96.7149 748.743L116.042 737.698V737.684L96.7164 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 704.536L96.7017 704.544V726.632L96.7149 726.64L116.042 715.595V715.581L96.7164 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 682.432L96.7017 682.44V704.528L96.7149 704.536L116.042 693.491V693.477L96.7164 682.432Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 660.329L96.7017 660.337V682.425L96.7149 682.433L116.042 671.388V671.374L96.7164 660.329Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 638.227L96.7017 638.234V660.322L96.7149 660.33L116.042 649.285V649.271L96.7164 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 616.124L96.7017 616.131V638.219L96.7149 638.227L116.042 627.182V627.168L96.7164 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 594.021L96.7017 594.028V616.116L96.7149 616.124L116.042 605.079V605.065L96.7164 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 571.917L96.7017 571.925V594.013L96.7149 594.021L116.042 582.976V582.962L96.7164 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 549.814L96.7017 549.822V571.91L96.7149 571.918L116.042 560.873V560.859L96.7164 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 527.711L96.7017 527.719V549.807L96.7149 549.815L116.042 538.77V538.756L96.7164 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 505.608L96.7017 505.616V527.704L96.7149 527.711L116.042 516.667V516.653L96.7164 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 483.505L96.7017 483.513V505.601L96.7149 505.608L116.042 494.564V494.55L96.7164 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 461.401L96.7017 461.409V483.497L96.7149 483.504L116.042 472.46V472.446L96.7164 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 439.298L96.7017 439.306V461.394L96.7149 461.402L116.042 450.357V450.343L96.7164 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 417.195L96.7017 417.203V439.291L96.7149 439.299L116.042 428.254V428.24L96.7164 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 395.092L96.7017 395.1V417.188L96.7149 417.196L116.042 406.151V406.137L96.7164 395.092Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 372.989L96.7017 372.997V395.085L96.7149 395.092L116.042 384.048V384.034L96.7164 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 350.886L96.7017 350.894V372.982L96.7149 372.989L116.042 361.945V361.931L96.7164 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 328.783L96.7017 328.791V350.879L96.7149 350.886L116.042 339.842V339.828L96.7164 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 306.68L96.7017 306.688V328.776L96.7149 328.783L116.042 317.739V317.725L96.7164 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 284.577L96.7017 284.585V306.673L96.7149 306.68L116.042 295.636V295.622L96.7164 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 262.473L96.7017 262.481V284.569L96.7149 284.576L116.042 273.532V273.518L96.7164 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 240.37L96.7017 240.378V262.466L96.7149 262.473L116.042 251.429V251.415L96.7164 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 218.267L96.7017 218.275V240.363L96.7149 240.37L116.042 229.326V229.312L96.7164 218.267Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 196.164L96.7017 196.172V218.26L96.7149 218.267L116.042 207.223V207.209L96.7164 196.164Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 174.061L96.7017 174.069V196.157L96.7149 196.164L116.042 185.12V185.106L96.7164 174.061Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 151.958L96.7017 151.966V174.054L96.7149 174.061L116.042 163.017V163.003L96.7164 151.958Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 129.855L96.7017 129.863V151.951L96.7149 151.958L116.042 140.914V140.9L96.7164 129.855Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 107.752L96.7017 107.76V129.848L96.7149 129.855L116.042 118.811V118.797L96.7164 107.752Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 85.6493L96.7017 85.6566V107.745L96.7149 107.752L116.042 96.7081V96.6935L96.7164 85.6493Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7164 63.5463L96.7017 63.5536V85.6421L96.7149 85.6494L116.042 74.6051V74.5905L96.7164 63.5463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 826.103V804L96.7017 815.052L116.042 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 804V781.897L96.7017 792.949L116.042 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 781.897V759.794L96.7017 770.846L116.042 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 759.794V737.691L96.7017 748.743L116.042 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 737.691V715.588L96.7017 726.64L116.042 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 715.588V693.485L96.7017 704.537L116.042 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 693.484V671.381L96.7017 682.433L116.042 693.484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 671.381V649.278L96.7017 660.33L116.042 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 649.278V627.175L96.7017 638.227L116.042 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 627.175V605.072L96.7017 616.124L116.042 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 605.072V582.969L96.7017 594.021L116.042 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 582.969V560.866L96.7017 571.918L116.042 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 560.866V538.763L96.7017 549.815L116.042 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 538.763V516.66L96.7017 527.712L116.042 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 516.66V494.557L96.7017 505.609L116.042 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 494.556V472.453L96.7017 483.505L116.042 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 472.453V450.35L96.7017 461.402L116.042 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 450.35V428.247L96.7017 439.299L116.042 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 428.247V406.144L96.7017 417.196L116.042 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 406.144V384.041L96.7017 395.093L116.042 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 384.041V361.938L96.7017 372.99L116.042 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 361.938V339.835L96.7017 350.887L116.042 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 339.835V317.732L96.7017 328.784L116.042 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 317.732V295.629L96.7017 306.681L116.042 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 295.629V273.526L96.7017 284.578L116.042 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 273.525V251.422L96.7017 262.474L116.042 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 251.422V229.319L96.7017 240.371L116.042 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 229.319V207.216L96.7017 218.268L116.042 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 207.216V185.113L96.7017 196.165L116.042 207.216Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 185.113V163.01L96.7017 174.062L116.042 185.113Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 163.01V140.907L96.7017 151.959L116.042 163.01Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 140.907V118.804L96.7017 129.856L116.042 140.907Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 118.804V96.7008L96.7017 107.753L116.042 118.804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 96.7009V74.5978L96.7017 85.6501L116.042 96.7009Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.042 74.5972V52.4941L96.7017 63.5464L116.042 74.5972Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 483.505L135.382 483.513V505.601L135.395 505.608L154.722 494.564V494.55L135.397 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 461.401L135.382 461.409V483.497L135.395 483.504L154.722 472.46V472.446L135.397 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 439.298L135.382 439.306V461.394L135.395 461.401L154.722 450.357V450.343L135.397 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 417.195L135.382 417.203V439.291L135.395 439.299L154.722 428.254V428.24L135.397 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 395.092L135.382 395.1V417.188L135.395 417.196L154.722 406.151V406.137L135.397 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 372.989L135.382 372.997V395.085L135.395 395.092L154.722 384.048V384.034L135.397 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 350.886L135.382 350.894V372.982L135.395 372.99L154.722 361.945V361.931L135.397 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 328.783L135.382 328.791V350.879L135.395 350.886L154.722 339.842V339.828L135.397 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 306.68L135.382 306.688V328.776L135.395 328.783L154.722 317.739V317.725L135.397 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 284.577L135.382 284.585V306.673L135.395 306.68L154.722 295.636V295.622L135.397 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 262.473L135.382 262.481V284.569L135.395 284.576L154.722 273.532V273.518L135.397 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.397 240.37L135.382 240.378V262.466L135.395 262.473L154.722 251.429V251.415L135.397 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 494.556V472.453L135.382 483.505L154.722 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 472.453V450.35L135.382 461.402L154.722 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 450.35V428.247L135.382 439.299L154.722 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 428.247V406.144L135.382 417.196L154.722 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 406.144V384.041L135.382 395.093L154.722 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 384.041V361.938L135.382 372.99L154.722 384.041Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 361.938V339.835L135.382 350.887L154.722 361.938Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 339.835V317.732L135.382 328.784L154.722 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 317.732V295.629L135.382 306.681L154.722 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 295.629V273.526L135.382 284.578L154.722 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 273.525V251.422L135.382 262.474L154.722 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 251.422V229.319L135.382 240.371L154.722 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 229.319V207.216L135.382 218.268L154.722 229.319Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 207.216V185.113L135.382 196.165L154.722 207.216Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.722 140.907V118.804L135.382 129.856L154.722 140.907Z",
    fill: "#B2D530"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 726.64L174.062 726.647V748.735L174.075 748.743L193.402 737.698V737.684L174.077 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 704.536L174.062 704.544V726.632L174.075 726.64L193.402 715.595V715.581L174.077 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 682.432L174.062 682.44V704.528L174.075 704.536L193.402 693.491V693.477L174.077 682.432Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 660.329L174.062 660.337V682.425L174.075 682.433L193.402 671.388V671.374L174.077 660.329Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 638.227L174.062 638.234V660.322L174.075 660.33L193.402 649.285V649.271L174.077 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 616.124L174.062 616.131V638.219L174.075 638.227L193.402 627.182V627.168L174.077 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 594.021L174.062 594.028V616.116L174.075 616.124L193.402 605.079V605.065L174.077 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 571.917L174.062 571.925V594.013L174.075 594.021L193.402 582.976V582.962L174.077 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 549.814L174.062 549.822V571.91L174.075 571.918L193.402 560.873V560.859L174.077 549.814Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 527.711L174.062 527.719V549.807L174.075 549.815L193.402 538.77V538.756L174.077 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 505.608L174.062 505.616V527.704L174.075 527.711L193.402 516.667V516.653L174.077 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 483.505L174.062 483.513V505.601L174.075 505.608L193.402 494.564V494.55L174.077 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 461.401L174.062 461.409V483.497L174.075 483.504L193.402 472.46V472.446L174.077 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 439.298L174.062 439.306V461.394L174.075 461.402L193.402 450.357V450.343L174.077 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 218.267L174.062 218.275V240.363L174.075 240.37L193.402 229.326V229.312L174.077 218.267Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 196.164L174.062 196.172V218.26L174.075 218.267L193.402 207.223V207.209L174.077 196.164Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 174.061L174.062 174.069V196.157L174.075 196.164L193.402 185.12V185.106L174.077 174.061Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 151.958L174.062 151.966V174.054L174.075 174.061L193.402 163.017V163.003L174.077 151.958Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 129.855L174.062 129.863V151.951L174.075 151.958L193.402 140.914V140.9L174.077 129.855Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 107.752L174.062 107.76V129.848L174.075 129.855L193.402 118.811V118.797L174.077 107.752Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 85.6493L174.062 85.6566V107.745L174.075 107.752L193.402 96.7081V96.6935L174.077 85.6493Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 63.5463L174.062 63.5536V85.6421L174.075 85.6494L193.402 74.6051V74.5905L174.077 63.5463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 41.4423L174.062 41.4496V63.5381L174.075 63.5454L193.402 52.5012V52.4866L174.077 41.4423Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 19.3393L174.062 19.3466V41.4351L174.075 41.4424L193.402 30.3981V30.3835L174.077 19.3393Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.077 -2.76373L174.062 -2.75644V19.3321L174.075 19.3394L193.402 8.29511V8.28052L174.077 -2.76373Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 737.691V715.588L174.062 726.64L193.402 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 715.588V693.485L174.062 704.537L193.402 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 693.484V671.381L174.062 682.433L193.402 693.484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 671.381V649.278L174.062 660.33L193.402 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 649.278V627.175L174.062 638.227L193.402 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 627.175V605.072L174.062 616.124L193.402 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 605.072V582.969L174.062 594.021L193.402 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 582.969V560.866L174.062 571.918L193.402 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 560.866V538.763L174.062 549.815L193.402 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 538.763V516.66L174.062 527.712L193.402 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 516.66V494.557L174.062 505.609L193.402 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 494.556V472.453L174.062 483.505L193.402 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 472.453V450.35L174.062 461.402L193.402 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 450.35V428.247L174.062 439.299L193.402 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 295.629V273.526L174.062 284.578L193.402 295.629Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 251.422V229.319L174.062 240.371L193.402 251.422Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 229.319V207.216L174.062 218.268L193.402 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 207.216V185.113L174.062 196.165L193.402 207.216Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 185.113V163.01L174.062 174.062L193.402 185.113Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 163.01V140.907L174.062 151.959L193.402 163.01Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 140.907V118.804L174.062 129.856L193.402 140.907Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 118.804V96.7008L174.062 107.753L193.402 118.804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 96.7009V74.5978L174.062 85.6501L193.402 96.7009Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 74.5969V52.4938L174.062 63.5461L193.402 74.5969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 52.4939V30.3908L174.062 41.4431L193.402 52.4939Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 30.3909V8.28778L174.062 19.3401L193.402 30.3909Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 8.28791V-13.8152L174.062 -2.76291L193.402 8.28791Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 1013.98L212.743 1013.99V1036.07L212.729 1036.08L193.402 1025.04V1025.02L212.728 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 991.876L212.743 991.883V1013.97L212.729 1013.98L193.402 1002.93V1002.92L212.728 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 969.773L212.743 969.78V991.868L212.729 991.876L193.402 980.831V980.817L212.728 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 947.67L212.743 947.677V969.765L212.729 969.773L193.402 958.728V958.714L212.728 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 925.567L212.743 925.574V947.662L212.729 947.67L193.402 936.625V936.611L212.728 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 903.463L212.743 903.47V925.558L212.729 925.566L193.402 914.521V914.507L212.728 903.463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 682.432L212.743 682.44V704.528L212.729 704.536L193.402 693.491V693.477L212.728 682.432Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 660.329L212.743 660.337V682.425L212.729 682.433L193.402 671.388V671.374L212.728 660.329Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 638.226L212.743 638.234V660.322L212.729 660.33L193.402 649.285V649.271L212.728 638.226Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 616.124L212.743 616.131V638.219L212.729 638.227L193.402 627.182V627.168L212.728 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 594.021L212.743 594.028V616.116L212.729 616.124L193.402 605.079V605.065L212.728 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 571.917L212.743 571.925V594.013L212.729 594.021L193.402 582.976V582.962L212.728 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 549.814L212.743 549.822V571.91L212.729 571.918L193.402 560.873V560.859L212.728 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 527.711L212.743 527.719V549.807L212.729 549.815L193.402 538.77V538.756L212.728 527.711Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 505.608L212.743 505.616V527.704L212.729 527.711L193.402 516.667V516.653L212.728 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 483.505L212.743 483.513V505.601L212.729 505.608L193.402 494.564V494.55L212.728 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.728 461.401L212.743 461.409V483.497L212.729 483.505L193.402 472.46V472.446L212.728 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 1025.03V1002.93L212.743 1013.98L193.402 1025.03Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 1002.93V980.824L212.743 991.876L193.402 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 980.824V958.721L212.743 969.773L193.402 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 958.721V936.618L212.743 947.67L193.402 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 936.618V914.515L212.743 925.567L193.402 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 715.588V693.485L212.743 704.537L193.402 715.588Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 693.484V671.381L212.743 682.433L193.402 693.484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 671.381V649.278L212.743 660.33L193.402 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 649.278V627.175L212.743 638.227L193.402 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 627.175V605.072L212.743 616.124L193.402 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 605.072V582.969L212.743 594.021L193.402 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 582.969V560.866L212.743 571.918L193.402 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 560.866V538.763L212.743 549.815L193.402 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 538.763V516.66L212.743 527.712L193.402 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 516.66V494.557L212.743 505.609L193.402 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 494.556V472.453L212.743 483.505L193.402 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.402 472.453V450.35L212.743 461.402L193.402 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 527.711L251.423 527.719V549.807L251.41 549.815L232.083 538.77V538.756L251.409 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 505.608L251.423 505.616V527.704L251.41 527.711L232.083 516.667V516.653L251.409 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 483.505L251.423 483.513V505.601L251.41 505.608L232.083 494.564V494.55L251.409 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 461.401L251.423 461.409V483.497L251.41 483.504L232.083 472.46V472.446L251.409 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 439.298L251.423 439.306V461.394L251.41 461.401L232.083 450.357V450.343L251.409 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 417.195L251.423 417.203V439.291L251.41 439.299L232.083 428.254V428.24L251.409 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 395.092L251.423 395.1V417.188L251.41 417.196L232.083 406.151V406.137L251.409 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 372.989L251.423 372.997V395.085L251.41 395.092L232.083 384.048V384.034L251.409 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 350.886L251.423 350.894V372.982L251.41 372.99L232.083 361.945V361.931L251.409 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 328.783L251.423 328.791V350.879L251.41 350.886L232.083 339.842V339.828L251.409 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 306.68L251.423 306.688V328.776L251.41 328.783L232.083 317.739V317.725L251.409 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 284.577L251.423 284.585V306.673L251.41 306.68L232.083 295.636V295.622L251.409 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 262.473L251.423 262.481V284.569L251.41 284.576L232.083 273.532V273.518L251.409 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 240.37L251.423 240.378V262.466L251.41 262.473L232.083 251.429V251.415L251.409 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 218.267L251.423 218.275V240.363L251.41 240.37L232.083 229.326V229.312L251.409 218.267Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 196.164L251.423 196.172V218.26L251.41 218.267L232.083 207.223V207.209L251.409 196.164Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 174.061L251.424 174.069V196.157L251.41 196.164L232.083 185.12V185.106L251.409 174.061Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 151.958L251.424 151.966V174.054L251.41 174.061L232.083 163.017V163.003L251.409 151.958Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 107.752L251.423 107.76V129.848L251.41 129.855L232.083 118.811V118.797L251.409 107.752Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 41.4423L251.423 41.4496V63.5381L251.41 63.5454L232.083 52.5012V52.4866L251.409 41.4423Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 19.3393L251.423 19.3466V41.4351L251.41 41.4424L232.083 30.3981V30.3835L251.409 19.3393Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.409 -2.76373L251.423 -2.75644V19.3321L251.41 19.3394L232.083 8.29511V8.28052L251.409 -2.76373Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 538.763V516.66L251.423 527.712L232.083 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 516.66V494.557L251.423 505.609L232.083 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 494.556V472.453L251.423 483.505L232.083 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 472.453V450.35L251.423 461.402L232.083 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 450.35V428.247L251.423 439.299L232.083 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 428.247V406.144L251.423 417.196L232.083 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 406.144V384.041L251.423 395.093L232.083 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 384.041V361.938L251.423 372.99L232.083 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 361.938V339.835L251.423 350.887L232.083 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 339.835V317.732L251.423 328.784L232.083 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 317.732V295.629L251.423 306.681L232.083 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 295.629V273.526L251.423 284.578L232.083 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 273.525V251.422L251.423 262.474L232.083 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 251.422V229.319L251.423 240.371L232.083 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 229.319V207.216L251.423 218.268L232.083 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 207.216V185.113L251.423 196.165L232.083 207.216Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 118.804V96.7008L251.423 107.753L232.083 118.804Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 74.5969V52.4938L251.423 63.5461L232.083 74.5969Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 52.4939V30.3908L251.423 41.4431L232.083 52.4939Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.083 8.28791V-13.8152L251.423 -2.76291L232.083 8.28791Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 1013.98L251.423 1013.99V1036.07L251.436 1036.08L270.763 1025.04V1025.02L251.438 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 991.876L251.423 991.883V1013.97L251.436 1013.98L270.763 1002.93V1002.92L251.438 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 969.773L251.423 969.78V991.868L251.436 991.876L270.763 980.831V980.817L251.438 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 947.67L251.423 947.677V969.765L251.436 969.773L270.763 958.729V958.714L251.438 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 925.567L251.423 925.574V947.662L251.436 947.67L270.763 936.625V936.611L251.438 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 903.464L251.423 903.471V925.559L251.436 925.567L270.763 914.522V914.508L251.438 903.464Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 881.36L251.423 881.367V903.455L251.436 903.463L270.763 892.418V892.404L251.438 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 859.257L251.423 859.264V881.352L251.436 881.36L270.763 870.315V870.301L251.438 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 837.154L251.423 837.161V859.249L251.436 859.257L270.763 848.212V848.198L251.438 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 815.051L251.423 815.058V837.146L251.436 837.154L270.763 826.109V826.095L251.438 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 792.948L251.423 792.956V815.044L251.436 815.052L270.763 804.007V803.993L251.438 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 770.845L251.423 770.853V792.941L251.436 792.949L270.763 781.904V781.89L251.438 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 748.743L251.423 748.75V770.838L251.436 770.846L270.763 759.801V759.787L251.438 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 726.64L251.423 726.647V748.735L251.436 748.743L270.763 737.698V737.684L251.438 726.64Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 638.227L251.423 638.234V660.322L251.436 660.33L270.763 649.285V649.271L251.438 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 616.124L251.423 616.131V638.219L251.436 638.227L270.763 627.182V627.168L251.438 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 594.021L251.423 594.028V616.116L251.436 616.124L270.763 605.079V605.065L251.438 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 571.917L251.423 571.925V594.013L251.436 594.021L270.763 582.976V582.962L251.438 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 549.814L251.423 549.822V571.91L251.436 571.918L270.763 560.873V560.859L251.438 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 527.711L251.423 527.719V549.807L251.436 549.815L270.763 538.77V538.756L251.438 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 505.608L251.423 505.616V527.704L251.436 527.711L270.763 516.667V516.653L251.438 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 483.505L251.423 483.513V505.601L251.436 505.608L270.763 494.564V494.55L251.438 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 461.401L251.423 461.409V483.497L251.436 483.505L270.763 472.46V472.446L251.438 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 439.298L251.423 439.306V461.394L251.436 461.402L270.763 450.357V450.343L251.438 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 417.195L251.423 417.203V439.291L251.436 439.299L270.763 428.254V428.24L251.438 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 395.092L251.423 395.1V417.188L251.436 417.196L270.763 406.151V406.137L251.438 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.438 372.989L251.423 372.997V395.085L251.436 395.092L270.763 384.048V384.034L251.438 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 1025.03V1002.93L251.423 1013.98L270.763 1025.03Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 1002.93V980.824L251.423 991.876L270.763 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 980.824V958.721L251.423 969.773L270.763 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 958.721V936.618L251.423 947.67L270.763 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 936.618V914.515L251.423 925.567L270.763 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 914.514V892.411L251.423 903.463L270.763 914.514Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 892.411V870.308L251.423 881.36L270.763 892.411Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 870.308V848.205L251.423 859.257L270.763 870.308Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 848.206V826.103L251.423 837.155L270.763 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 826.103V804L251.423 815.052L270.763 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 804V781.897L251.423 792.949L270.763 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 781.897V759.794L251.423 770.846L270.763 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 759.794V737.691L251.423 748.743L270.763 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 737.691V715.588L251.423 726.64L270.763 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 649.278V627.175L251.423 638.227L270.763 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 627.175V605.072L251.423 616.124L270.763 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 605.072V582.969L251.423 594.021L270.763 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 582.969V560.866L251.423 571.918L270.763 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 560.866V538.763L251.423 549.815L270.763 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 538.763V516.66L251.423 527.712L270.763 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 516.66V494.557L251.423 505.609L270.763 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 494.556V472.453L251.423 483.505L270.763 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 472.453V450.35L251.423 461.402L270.763 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 450.35V428.247L251.423 439.299L270.763 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 428.247V406.144L251.423 417.196L270.763 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 406.144V384.041L251.423 395.093L270.763 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.763 384.041V361.938L251.423 372.99L270.763 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 1002.93L309.443 1002.93V1025.02L309.43 1025.03L290.103 1013.99V1013.97L309.429 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 980.824L309.443 980.831V1002.92L309.43 1002.93L290.103 991.883V991.868L309.429 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 958.721L309.443 958.728V980.817L309.43 980.824L290.103 969.78V969.765L309.429 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 870.309L309.443 870.316V892.405L309.43 892.412L290.103 881.368V881.353L309.429 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 848.206L309.443 848.213V870.302L309.43 870.309L290.103 859.265V859.25L309.429 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 826.103L309.443 826.11V848.199L309.43 848.206L290.103 837.162V837.147L309.429 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 804L309.443 804.007V826.096L309.43 826.103L290.103 815.059V815.044L309.429 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 781.897L309.443 781.904V803.993L309.43 804L290.103 792.956V792.941L309.429 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 759.794L309.443 759.801V781.89L309.43 781.897L290.103 770.853V770.838L309.429 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 737.691L309.443 737.698V759.787L309.43 759.794L290.103 748.75V748.735L309.429 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 715.588L309.443 715.595V737.684L309.43 737.691L290.103 726.647V726.632L309.429 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 693.485L309.443 693.492V715.581L309.43 715.588L290.103 704.544V704.529L309.429 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 671.381L309.443 671.388V693.477L309.43 693.484L290.103 682.44V682.425L309.429 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 649.278L309.443 649.285V671.374L309.43 671.381L290.103 660.337V660.322L309.429 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 627.175L309.443 627.182V649.271L309.43 649.278L290.103 638.234V638.219L309.429 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 605.072L309.443 605.079V627.168L309.43 627.175L290.103 616.131V616.116L309.429 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 582.969L309.443 582.976V605.065L309.43 605.072L290.103 594.028V594.013L309.429 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 560.866L309.443 560.873V582.962L309.43 582.969L290.103 571.925V571.91L309.429 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 538.763L309.443 538.77V560.859L309.43 560.866L290.103 549.822V549.807L309.429 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 516.66L309.443 516.667V538.756L309.43 538.763L290.103 527.719V527.704L309.429 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 472.453L309.443 472.46V494.549L309.43 494.556L290.103 483.512V483.497L309.429 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 450.35L309.443 450.357V472.446L309.43 472.453L290.103 461.409V461.394L309.429 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 428.247L309.443 428.254V450.343L309.43 450.35L290.103 439.306V439.291L309.429 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 406.144L309.443 406.151V428.24L309.43 428.247L290.103 417.203V417.188L309.429 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 384.041L309.443 384.048V406.137L309.43 406.144L290.103 395.1V395.085L309.429 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 361.938L309.443 361.945V384.034L309.43 384.041L290.103 372.997V372.982L309.429 361.938Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 339.835L309.443 339.842V361.931L309.43 361.938L290.103 350.894V350.879L309.429 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 317.732L309.443 317.739V339.828L309.43 339.835L290.103 328.791V328.776L309.429 317.732Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 295.629L309.443 295.636V317.725L309.43 317.732L290.103 306.688V306.673L309.429 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 273.526L309.443 273.533V295.622L309.43 295.629L290.103 284.585V284.57L309.429 273.526Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.429 251.422L309.443 251.429V273.518L309.43 273.525L290.103 262.481V262.466L309.429 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 1013.98V991.876L309.443 1002.93L290.103 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 991.876V969.773L309.443 980.825L290.103 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 969.773V947.67L309.443 958.722L290.103 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 903.463V881.36L309.443 892.412L290.103 903.463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 881.36V859.257L309.443 870.309L290.103 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 859.257V837.154L309.443 848.206L290.103 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 837.154V815.051L309.443 826.103L290.103 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 815.051V792.948L309.443 804L290.103 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 792.949V770.845L309.443 781.898L290.103 792.949Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 770.846V748.743L309.443 759.795L290.103 770.846Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 748.743V726.64L309.443 737.692L290.103 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 726.64V704.536L309.443 715.589L290.103 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 704.536V682.432L309.443 693.485L290.103 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 682.433V660.329L309.443 671.382L290.103 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 660.33V638.227L309.443 649.279L290.103 660.33Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 638.227V616.124L309.443 627.176L290.103 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 616.124V594.021L309.443 605.073L290.103 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 594.021V571.917L309.443 582.97L290.103 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 571.918V549.814L309.443 560.867L290.103 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 549.815V527.711L309.443 538.764L290.103 549.815Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 527.711V505.608L309.443 516.661L290.103 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 461.402V439.298L309.443 450.351L290.103 461.402Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 439.299V417.195L309.443 428.248L290.103 439.299Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 417.196V395.092L309.443 406.145L290.103 417.196Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 395.092V372.989L309.443 384.042L290.103 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 372.99V350.886L309.443 361.939L290.103 372.99Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 350.886V328.783L309.443 339.836L290.103 350.886Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 328.783V306.68L309.443 317.733L290.103 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 306.68V284.577L309.443 295.63L290.103 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 284.576V262.473L309.443 273.526L290.103 284.576Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.103 262.473V240.37L309.443 251.423L290.103 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 770.845L328.784 770.853V792.941L328.77 792.949L309.443 781.904V781.89L328.769 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 748.742L328.784 748.75V770.838L328.77 770.846L309.443 759.801V759.787L328.769 748.742Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 726.64L328.784 726.647V748.735L328.77 748.743L309.443 737.698V737.684L328.769 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 638.227L328.784 638.234V660.322L328.77 660.33L309.443 649.285V649.271L328.769 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 616.124L328.784 616.131V638.219L328.77 638.227L309.443 627.182V627.168L328.769 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 594.021L328.784 594.028V616.116L328.77 616.124L309.443 605.079V605.065L328.769 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 571.917L328.784 571.925V594.013L328.77 594.021L309.443 582.976V582.962L328.769 571.917Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 549.814L328.784 549.822V571.91L328.77 571.918L309.443 560.873V560.859L328.769 549.814Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 527.711L328.784 527.719V549.807L328.77 549.815L309.443 538.77V538.756L328.769 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 505.608L328.784 505.616V527.704L328.77 527.711L309.443 516.667V516.653L328.769 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 483.505L328.784 483.513V505.601L328.77 505.608L309.443 494.564V494.55L328.769 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 461.401L328.784 461.409V483.497L328.77 483.504L309.443 472.46V472.446L328.769 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 439.298L328.784 439.306V461.394L328.77 461.402L309.443 450.357V450.343L328.769 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 417.195L328.784 417.203V439.291L328.77 439.299L309.443 428.254V428.24L328.769 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 395.092L328.784 395.1V417.188L328.77 417.196L309.443 406.151V406.137L328.769 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 372.989L328.784 372.997V395.085L328.77 395.092L309.443 384.048V384.034L328.769 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 350.886L328.784 350.894V372.982L328.77 372.989L309.443 361.945V361.931L328.769 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 328.783L328.784 328.791V350.879L328.77 350.886L309.443 339.842V339.828L328.769 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 306.68L328.784 306.688V328.776L328.77 328.783L309.443 317.739V317.725L328.769 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 284.577L328.784 284.585V306.673L328.77 306.68L309.443 295.636V295.622L328.769 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 240.37L328.784 240.378V262.466L328.77 262.473L309.443 251.429V251.415L328.769 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 218.267L328.784 218.275V240.363L328.77 240.37L309.443 229.326V229.312L328.769 218.267Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 196.164L328.784 196.172V218.26L328.77 218.267L309.443 207.223V207.209L328.769 196.164Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 174.061L328.784 174.069V196.157L328.77 196.164L309.443 185.12V185.106L328.769 174.061Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 151.958L328.784 151.966V174.054L328.77 174.061L309.443 163.017V163.003L328.769 151.958Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 129.855L328.784 129.863V151.951L328.77 151.958L309.443 140.914V140.9L328.769 129.855Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 107.752L328.784 107.76V129.848L328.77 129.855L309.443 118.811V118.797L328.769 107.752Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 85.6493L328.784 85.6566V107.745L328.77 107.752L309.443 96.7081V96.6935L328.769 85.6493Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 63.5463L328.784 63.5536V85.6421L328.77 85.6494L309.443 74.6051V74.5905L328.769 63.5463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 41.4423L328.784 41.4496V63.5381L328.77 63.5454L309.443 52.5012V52.4866L328.769 41.4423Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.769 19.3393L328.784 19.3466V41.4351L328.77 41.4424L309.443 30.3981V30.3835L328.769 19.3393Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 781.897V759.794L328.784 770.846L309.443 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 759.794V737.691L328.784 748.743L309.443 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 737.691V715.588L328.784 726.64L309.443 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 671.381V649.278L328.784 660.33L309.443 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 649.278V627.175L328.784 638.227L309.443 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 627.175V605.072L328.784 616.124L309.443 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 605.072V582.969L328.784 594.021L309.443 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 582.969V560.866L328.784 571.918L309.443 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 560.866V538.763L328.784 549.815L309.443 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 538.763V516.66L328.784 527.712L309.443 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 516.66V494.557L328.784 505.609L309.443 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 494.556V472.453L328.784 483.505L309.443 494.556Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 472.453V450.35L328.784 461.402L309.443 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 450.35V428.247L328.784 439.299L309.443 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 428.247V406.144L328.784 417.196L309.443 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 406.144V384.041L328.784 395.093L309.443 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 384.041V361.938L328.784 372.99L309.443 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 361.938V339.835L328.784 350.887L309.443 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 339.835V317.732L328.784 328.784L309.443 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 317.732V295.629L328.784 306.681L309.443 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 295.629V273.526L328.784 284.578L309.443 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 229.319V207.216L328.784 218.268L309.443 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 207.216V185.113L328.784 196.165L309.443 207.216Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 185.113V163.01L328.784 174.062L309.443 185.113Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 163.01V140.907L328.784 151.959L309.443 163.01Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 140.907V118.804L328.784 129.856L309.443 140.907Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 118.804V96.7008L328.784 107.753L309.443 118.804Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 96.7009V74.5978L328.784 85.6501L309.443 96.7009Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 74.5969V52.4938L328.784 63.5461L309.443 74.5969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 52.4939V30.3908L328.784 41.4431L309.443 52.4939Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.443 30.3909V8.28778L328.784 19.3401L309.443 30.3909Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 1002.93L348.124 1002.93V1025.02L348.111 1025.03L328.784 1013.99V1013.97L348.109 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 980.824L348.124 980.831V1002.92L348.111 1002.93L328.784 991.883V991.868L348.109 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 958.721L348.124 958.728V980.817L348.111 980.824L328.784 969.78V969.765L348.109 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 936.618L348.124 936.625V958.714L348.111 958.721L328.784 947.677V947.662L348.109 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 914.515L348.124 914.522V936.611L348.111 936.618L328.784 925.574V925.559L348.109 914.515Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 848.206L348.124 848.213V870.302L348.111 870.309L328.784 859.265V859.25L348.109 848.206Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 781.897L348.124 781.904V803.993L348.111 804L328.784 792.956V792.941L348.109 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 759.794L348.124 759.801V781.89L348.111 781.897L328.784 770.853V770.838L348.109 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 737.691L348.124 737.698V759.787L348.111 759.794L328.784 748.75V748.735L348.109 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 715.588L348.124 715.595V737.684L348.111 737.691L328.784 726.647V726.632L348.109 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 693.485L348.124 693.492V715.581L348.111 715.588L328.784 704.544V704.529L348.109 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 671.381L348.124 671.388V693.477L348.111 693.484L328.784 682.44V682.425L348.109 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 649.278L348.124 649.285V671.374L348.111 671.381L328.784 660.337V660.322L348.109 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 627.175L348.124 627.182V649.271L348.111 649.278L328.784 638.234V638.219L348.109 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 605.072L348.124 605.079V627.168L348.111 627.175L328.784 616.131V616.116L348.109 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 582.969L348.124 582.976V605.065L348.111 605.072L328.784 594.028V594.013L348.109 582.969Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 472.453L348.124 472.46V494.549L348.111 494.556L328.784 483.512V483.497L348.109 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 450.35L348.124 450.357V472.446L348.111 472.453L328.784 461.409V461.394L348.109 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 428.247L348.124 428.254V450.343L348.111 450.35L328.784 439.306V439.291L348.109 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 406.144L348.124 406.151V428.24L348.111 428.247L328.784 417.203V417.188L348.109 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 339.835L348.124 339.842V361.931L348.111 361.938L328.784 350.894V350.879L348.109 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 317.732L348.124 317.739V339.828L348.111 339.835L328.784 328.791V328.776L348.109 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 295.629L348.124 295.636V317.725L348.111 317.732L328.784 306.688V306.673L348.109 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 273.526L348.124 273.533V295.622L348.111 295.629L328.784 284.585V284.57L348.109 273.526Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.109 251.422L348.124 251.429V273.518L348.111 273.525L328.784 262.481V262.466L348.109 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 1013.98V991.876L348.124 1002.93L328.784 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 991.876V969.773L348.124 980.825L328.784 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 969.773V947.67L348.124 958.722L328.784 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 947.67V925.567L348.124 936.619L328.784 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 815.051V792.948L348.124 804L328.784 815.051Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 792.949V770.845L348.124 781.898L328.784 792.949Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 770.846V748.743L348.124 759.795L328.784 770.846Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 748.743V726.64L348.124 737.692L328.784 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 726.64V704.536L348.124 715.589L328.784 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 704.536V682.432L348.124 693.485L328.784 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 682.433V660.329L348.124 671.382L328.784 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 660.33V638.227L348.124 649.279L328.784 660.33Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 638.227V616.124L348.124 627.176L328.784 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 616.124V594.021L348.124 605.073L328.784 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 594.021V571.917L348.124 582.97L328.784 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 571.918V549.814L348.124 560.867L328.784 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 549.815V527.711L348.124 538.764L328.784 549.815Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 527.711V505.608L348.124 516.661L328.784 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 505.608V483.505L348.124 494.558L328.784 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 461.402V439.298L348.124 450.351L328.784 461.402Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 439.299V417.195L348.124 428.248L328.784 439.299Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 417.196V395.092L348.124 406.145L328.784 417.196Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 395.092V372.989L348.124 384.042L328.784 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 372.99V350.886L348.124 361.939L328.784 372.99Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 350.886V328.783L348.124 339.836L328.784 350.886Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 328.783V306.68L348.124 317.733L328.784 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 306.68V284.577L348.124 295.63L328.784 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 284.576V262.473L348.124 273.526L328.784 284.576Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.784 262.473V240.37L348.124 251.423L328.784 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 1013.98L367.464 1013.99V1036.07L367.451 1036.08L348.124 1025.04V1025.02L367.449 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 991.876L367.464 991.883V1013.97L367.451 1013.98L348.124 1002.93V1002.92L367.449 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 969.773L367.464 969.78V991.868L367.451 991.876L348.124 980.831V980.817L367.449 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 947.67L367.464 947.677V969.765L367.451 969.773L348.124 958.729V958.714L367.449 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 925.567L367.464 925.574V947.662L367.451 947.67L348.124 936.625V936.611L367.449 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 859.257L367.464 859.264V881.352L367.451 881.36L348.124 870.315V870.301L367.449 859.257Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 792.948L367.464 792.955V815.043L367.451 815.051L348.124 804.006V803.992L367.449 792.948Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 770.845L367.464 770.853V792.941L367.451 792.949L348.124 781.904V781.89L367.449 770.845Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 748.743L367.464 748.75V770.838L367.451 770.846L348.124 759.801V759.787L367.449 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 726.64L367.464 726.647V748.735L367.451 748.743L348.124 737.698V737.684L367.449 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 704.536L367.464 704.544V726.632L367.451 726.64L348.124 715.595V715.581L367.449 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 682.432L367.464 682.44V704.528L367.451 704.536L348.124 693.491V693.477L367.449 682.432Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 660.329L367.464 660.337V682.425L367.451 682.433L348.124 671.388V671.374L367.449 660.329Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 638.227L367.464 638.234V660.322L367.451 660.33L348.124 649.285V649.271L367.449 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 616.124L367.464 616.131V638.219L367.451 638.227L348.124 627.182V627.168L367.449 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 505.608L367.464 505.616V527.704L367.451 527.711L348.124 516.667V516.653L367.449 505.608Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 483.505L367.464 483.513V505.601L367.451 505.608L348.124 494.564V494.55L367.449 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 461.401L367.464 461.409V483.497L367.451 483.505L348.124 472.46V472.446L367.449 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 439.298L367.464 439.306V461.394L367.451 461.402L348.124 450.357V450.343L367.449 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 417.195L367.464 417.203V439.291L367.451 439.299L348.124 428.254V428.24L367.449 417.195Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 395.092L367.464 395.1V417.188L367.451 417.196L348.124 406.151V406.137L367.449 395.092Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 350.886L367.464 350.894V372.982L367.451 372.99L348.124 361.945V361.931L367.449 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 328.783L367.464 328.791V350.879L367.451 350.886L348.124 339.842V339.828L367.449 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 306.68L367.464 306.688V328.776L367.451 328.783L348.124 317.739V317.725L367.449 306.68Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 284.577L367.464 284.585V306.673L367.451 306.68L348.124 295.636V295.622L367.449 284.577Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.449 262.473L367.464 262.481V284.569L367.451 284.576L348.124 273.532V273.518L367.449 262.473Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 1025.03V1002.93L367.464 1013.98L348.124 1025.03Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 1002.93V980.824L367.464 991.876L348.124 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 980.824V958.721L367.464 969.773L348.124 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 958.721V936.618L367.464 947.67L348.124 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 826.103V804L367.464 815.052L348.124 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 804V781.897L367.464 792.949L348.124 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 781.897V759.794L367.464 770.846L348.124 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 759.794V737.691L367.464 748.743L348.124 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 737.691V715.588L367.464 726.64L348.124 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 715.588V693.485L367.464 704.537L348.124 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 693.484V671.381L367.464 682.433L348.124 693.484Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 671.381V649.278L367.464 660.33L348.124 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 649.278V627.175L367.464 638.227L348.124 649.278Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 627.175V605.072L367.464 616.124L348.124 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 605.072V582.969L367.464 594.021L348.124 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 582.969V560.866L367.464 571.918L348.124 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 560.866V538.763L367.464 549.815L348.124 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 538.763V516.66L367.464 527.712L348.124 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 516.66V494.557L367.464 505.609L348.124 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 472.453V450.35L367.464 461.402L348.124 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 450.35V428.247L367.464 439.299L348.124 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 428.247V406.144L367.464 417.196L348.124 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 406.144V384.041L367.464 395.093L348.124 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 384.041V361.938L367.464 372.99L348.124 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 339.835V317.732L367.464 328.784L348.124 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 317.732V295.629L367.464 306.681L348.124 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 295.629V273.526L367.464 284.578L348.124 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.124 273.525V251.422L367.464 262.474L348.124 273.525Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 450.35L386.804 450.357V472.446L386.791 472.453L367.464 461.409V461.394L386.789 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 428.247L386.804 428.254V450.343L386.791 450.35L367.464 439.306V439.291L386.789 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 406.144L386.804 406.151V428.24L386.791 428.247L367.464 417.203V417.188L386.789 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 384.041L386.804 384.048V406.137L386.791 406.144L367.464 395.1V395.085L386.789 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 361.938L386.804 361.945V384.034L386.791 384.041L367.464 372.997V372.982L386.789 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 339.835L386.804 339.842V361.931L386.791 361.938L367.464 350.894V350.879L386.789 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 317.732L386.804 317.739V339.828L386.791 339.835L367.464 328.791V328.776L386.789 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 295.629L386.804 295.636V317.725L386.791 317.732L367.464 306.688V306.673L386.789 295.629Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 273.526L386.804 273.533V295.622L386.791 295.629L367.464 284.585V284.57L386.789 273.526Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 163.01L386.804 163.017V185.106L386.791 185.113L367.464 174.069V174.054L386.789 163.01Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 52.4938L386.804 52.5011V74.5896L386.791 74.5969L367.464 63.5526V63.538L386.789 52.4938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.789 8.28778L386.804 8.29507V30.3836L386.791 30.3909L367.464 19.3466V19.332L386.789 8.28778Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 461.401V439.298L386.804 450.351L367.464 461.401Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 439.299V417.195L386.804 428.248L367.464 439.299Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 417.196V395.092L386.804 406.145L367.464 417.196Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 395.092V372.989L386.804 384.042L367.464 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 372.99V350.886L386.804 361.939L367.464 372.99Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 350.886V328.783L386.804 339.836L367.464 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 85.6494V63.5463L386.804 74.5985L367.464 85.6494Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 63.5454V41.4423L386.804 52.4946L367.464 63.5454Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.464 19.3394V-2.76367L386.804 8.2886L367.464 19.3394Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 936.618L464.165 936.625V958.714L464.178 958.721L483.505 947.677V947.662L464.18 936.618Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 848.205L464.165 848.212V870.301L464.178 870.308L483.505 859.264V859.249L464.18 848.205Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 826.103L464.165 826.11V848.199L464.178 848.206L483.505 837.162V837.147L464.18 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 781.897L464.165 781.904V803.993L464.178 804L483.505 792.956V792.941L464.18 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 759.794L464.165 759.801V781.89L464.178 781.897L483.505 770.853V770.838L464.18 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 715.588L464.165 715.595V737.684L464.178 737.691L483.505 726.647V726.632L464.18 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 693.485L464.165 693.492V715.581L464.178 715.588L483.505 704.544V704.529L464.18 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 649.278L464.165 649.285V671.374L464.178 671.381L483.505 660.337V660.322L464.18 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 627.175L464.165 627.182V649.271L464.178 649.278L483.505 638.234V638.219L464.18 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 605.072L464.165 605.079V627.168L464.178 627.175L483.505 616.131V616.116L464.18 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 582.969L464.165 582.976V605.065L464.178 605.072L483.505 594.028V594.013L464.18 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.18 560.866L464.165 560.873V582.962L464.178 582.969L483.505 571.925V571.91L464.18 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 837.154V815.051L464.165 826.103L483.505 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 815.052V792.948L464.165 804.001L483.505 815.052Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 792.949V770.845L464.165 781.898L483.505 792.949Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 748.743V726.64L464.165 737.692L483.505 748.743Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 726.64V704.536L464.165 715.589L483.505 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 704.536V682.432L464.165 693.485L483.505 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 682.433V660.329L464.165 671.382L483.505 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 660.33V638.226L464.165 649.279L483.505 660.33Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 638.227V616.124L464.165 627.176L483.505 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 616.124V594.021L464.165 605.073L483.505 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 594.021V571.917L464.165 582.97L483.505 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.505 571.918V549.814L464.165 560.867L483.505 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 1002.93L502.846 1002.93V1025.02L502.859 1025.03L522.186 1013.99V1013.97L502.86 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 980.824L502.846 980.831V1002.92L502.859 1002.93L522.186 991.883V991.868L502.86 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 958.721L502.846 958.728V980.817L502.859 980.824L522.186 969.78V969.765L502.86 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 936.618L502.846 936.625V958.714L502.859 958.721L522.186 947.677V947.662L502.86 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 914.515L502.846 914.522V936.611L502.859 936.618L522.186 925.574V925.559L502.86 914.515Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 892.411L502.846 892.418V914.507L502.859 914.514L522.186 903.47V903.455L502.86 892.411Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 870.308L502.846 870.315V892.404L502.859 892.411L522.186 881.367V881.352L502.86 870.308Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 848.205L502.846 848.212V870.301L502.859 870.308L522.186 859.264V859.249L502.86 848.205Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 826.103L502.846 826.11V848.199L502.859 848.206L522.186 837.162V837.147L502.86 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 804L502.846 804.007V826.096L502.859 826.103L522.186 815.059V815.044L502.86 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 781.897L502.846 781.904V803.993L502.859 804L522.186 792.956V792.941L502.86 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 759.794L502.846 759.801V781.89L502.859 781.897L522.186 770.853V770.838L502.86 759.794Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 715.588L502.846 715.595V737.684L502.859 737.691L522.186 726.647V726.632L502.86 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 671.381L502.846 671.388V693.477L502.859 693.484L522.186 682.44V682.425L502.86 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 649.278L502.846 649.285V671.374L502.859 671.381L522.186 660.337V660.322L502.86 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 627.175L502.846 627.182V649.271L502.859 649.278L522.186 638.234V638.219L502.86 627.175Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 582.969L502.846 582.976V605.065L502.859 605.072L522.186 594.028V594.013L502.86 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 560.866L502.846 560.873V582.962L502.859 582.969L522.186 571.925V571.91L502.86 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 538.763L502.846 538.77V560.859L502.859 560.866L522.186 549.822V549.807L502.86 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 516.66L502.846 516.667V538.756L502.859 538.763L522.186 527.719V527.704L502.86 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 450.35L502.846 450.357V472.446L502.859 472.453L522.186 461.409V461.394L502.86 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.86 428.247L502.846 428.254V450.343L502.859 450.35L522.186 439.306V439.291L502.86 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 1036.08V1013.98L502.846 1025.03L522.186 1036.08Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 1013.98V991.876L502.846 1002.93L522.186 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 991.876V969.773L502.846 980.825L522.186 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 969.773V947.67L502.846 958.722L522.186 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 947.67V925.567L502.846 936.619L522.186 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 925.566V903.463L502.846 914.515L522.186 925.566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 903.463V881.36L502.846 892.412L522.186 903.463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 881.36V859.257L502.846 870.309L522.186 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 859.257V837.154L502.846 848.206L522.186 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 837.154V815.051L502.846 826.103L522.186 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 815.052V792.948L502.846 804.001L522.186 815.052Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 792.949V770.845L502.846 781.898L522.186 792.949Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 704.536V682.432L502.846 693.485L522.186 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 682.433V660.329L502.846 671.382L522.186 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 660.33V638.226L502.846 649.279L522.186 660.33Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 571.918V549.814L502.846 560.867L522.186 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 527.711V505.608L502.846 516.661L522.186 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 483.505V461.401L502.846 472.454L522.186 483.505Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 461.402V439.298L502.846 450.351L522.186 461.402Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 439.298V417.195L502.846 428.248L522.186 439.298Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 737.691L541.526 737.698V759.787L541.513 759.794L522.186 748.75V748.735L541.511 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 715.588L541.526 715.595V737.684L541.513 737.691L522.186 726.647V726.632L541.511 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 693.485L541.526 693.492V715.581L541.513 715.588L522.186 704.544V704.529L541.511 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 671.381L541.526 671.388V693.477L541.513 693.484L522.186 682.44V682.425L541.511 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 649.278L541.526 649.285V671.374L541.513 671.381L522.186 660.337V660.322L541.511 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 627.175L541.526 627.182V649.271L541.513 649.278L522.186 638.234V638.219L541.511 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 605.072L541.526 605.079V627.168L541.513 627.175L522.186 616.131V616.116L541.511 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 582.969L541.526 582.976V605.065L541.513 605.072L522.186 594.028V594.013L541.511 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 560.866L541.526 560.873V582.962L541.513 582.969L522.186 571.925V571.91L541.511 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 538.763L541.526 538.77V560.859L541.513 560.866L522.186 549.822V549.807L541.511 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 516.66L541.526 516.667V538.756L541.513 538.763L522.186 527.719V527.704L541.511 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 494.557L541.526 494.564V516.653L541.513 516.66L522.186 505.616V505.601L541.511 494.557Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 472.453L541.526 472.46V494.549L541.513 494.556L522.186 483.512V483.497L541.511 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 450.35L541.526 450.357V472.446L541.513 472.453L522.186 461.409V461.394L541.511 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 428.247L541.526 428.254V450.343L541.513 450.35L522.186 439.306V439.291L541.511 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 406.144L541.526 406.151V428.24L541.513 428.247L522.186 417.203V417.188L541.511 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.512 384.041L541.526 384.048V406.137L541.513 406.144L522.186 395.1V395.085L541.512 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.512 361.938L541.526 361.945V384.034L541.513 384.041L522.186 372.997V372.982L541.512 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 339.835L541.526 339.842V361.931L541.513 361.938L522.186 350.894V350.879L541.511 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 317.732L541.526 317.739V339.828L541.513 339.835L522.186 328.791V328.776L541.511 317.732Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 295.629L541.526 295.636V317.725L541.513 317.732L522.186 306.688V306.673L541.511 295.629Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 273.526L541.526 273.533V295.622L541.513 295.629L522.186 284.585V284.57L541.511 273.526Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 251.422L541.526 251.429V273.518L541.513 273.525L522.186 262.481V262.466L541.511 251.422Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 229.319L541.526 229.326V251.415L541.513 251.422L522.186 240.378V240.363L541.511 229.319Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 185.113L541.526 185.12V207.209L541.513 207.216L522.186 196.172V196.157L541.511 185.113Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 163.01L541.526 163.017V185.106L541.513 185.113L522.186 174.069V174.054L541.511 163.01Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 118.804L541.526 118.811V140.9L541.513 140.907L522.186 129.863V129.848L541.511 118.804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 96.7008L541.526 96.7081V118.797L541.513 118.804L522.186 107.76V107.745L541.511 96.7008Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 74.5978L541.526 74.6051V96.6936L541.513 96.7009L522.186 85.6566V85.642L541.511 74.5978Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 52.4938L541.526 52.5011V74.5896L541.513 74.5969L522.186 63.5527V63.5381L541.511 52.4938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 30.3908L541.526 30.3981V52.4866L541.513 52.4939L522.186 41.4496V41.4351L541.511 30.3908Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 8.28778L541.526 8.29507V30.3836L541.513 30.3909L522.186 19.3466V19.332L541.511 8.28778Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.511 -13.8152L541.526 -13.808V8.28055L541.513 8.28785L522.186 -2.75641V-2.77099L541.511 -13.8152Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 748.743V726.64L541.526 737.692L522.186 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 726.64V704.536L541.526 715.589L522.186 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 704.536V682.432L541.526 693.485L522.186 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 682.433V660.329L541.526 671.382L522.186 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 660.33V638.227L541.526 649.279L522.186 660.33Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 638.227V616.124L541.526 627.176L522.186 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 616.124V594.021L541.526 605.073L522.186 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 594.021V571.917L541.526 582.97L522.186 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 571.918V549.814L541.526 560.867L522.186 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 549.815V527.711L541.526 538.764L522.186 549.815Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 527.711V505.608L541.526 516.661L522.186 527.711Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 505.608V483.505L541.526 494.558L522.186 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 483.504V461.401L541.526 472.454L522.186 483.504Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 461.402V439.298L541.526 450.351L522.186 461.402Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 439.299V417.195L541.526 428.248L522.186 439.299Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 417.196V395.092L541.526 406.145L522.186 417.196Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 395.092V372.989L541.526 384.042L522.186 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 372.989V350.886L541.526 361.939L522.186 372.989Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 350.886V328.783L541.526 339.836L522.186 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 328.783V306.68L541.526 317.733L522.186 328.783Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 284.576V262.473L541.526 273.526L522.186 284.576Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 240.37V218.267L541.526 229.32L522.186 240.37Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 218.267V196.164L541.526 207.217L522.186 218.267Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 174.061V151.958L541.526 163.011L522.186 174.061Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 129.855V107.752L541.526 118.805L522.186 129.855Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 107.752V85.6493L541.526 96.7016L522.186 107.752Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 85.6494V63.5463L541.526 74.5985L522.186 85.6494Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 63.5454V41.4423L541.526 52.4946L522.186 63.5454Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 41.4424V19.3393L541.526 30.3916L522.186 41.4424Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.186 19.3394V-2.76373L541.526 8.28854L522.186 19.3394Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 1002.93L541.526 1002.93V1025.02L541.539 1025.03L560.866 1013.99V1013.97L541.541 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 980.824L541.526 980.831V1002.92L541.539 1002.93L560.866 991.883V991.868L541.541 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 958.721L541.526 958.728V980.817L541.539 980.824L560.866 969.78V969.765L541.541 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 936.618L541.526 936.625V958.714L541.539 958.721L560.866 947.677V947.662L541.541 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 914.515L541.526 914.522V936.611L541.539 936.618L560.866 925.574V925.559L541.541 914.515Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 892.411L541.526 892.418V914.507L541.539 914.514L560.866 903.47V903.455L541.541 892.411Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 870.308L541.526 870.315V892.404L541.539 892.411L560.866 881.367V881.352L541.541 870.308Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 848.205L541.526 848.212V870.301L541.539 870.308L560.866 859.264V859.249L541.541 848.205Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 826.103L541.526 826.11V848.199L541.539 848.206L560.866 837.162V837.147L541.541 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 804L541.526 804.007V826.096L541.539 826.103L560.866 815.059V815.044L541.541 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 759.794L541.526 759.801V781.89L541.539 781.897L560.866 770.853V770.838L541.541 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 737.691L541.526 737.698V759.787L541.539 759.794L560.866 748.75V748.735L541.541 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 715.588L541.526 715.595V737.684L541.539 737.691L560.866 726.647V726.632L541.541 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 693.485L541.526 693.492V715.581L541.539 715.588L560.866 704.544V704.529L541.541 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 671.381L541.526 671.388V693.477L541.539 693.484L560.866 682.44V682.425L541.541 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 627.175L541.526 627.182V649.271L541.539 649.278L560.866 638.234V638.219L541.541 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 605.072L541.526 605.079V627.168L541.539 627.175L560.866 616.131V616.116L541.541 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 582.969L541.526 582.976V605.065L541.539 605.072L560.866 594.028V594.013L541.541 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 560.866L541.526 560.873V582.962L541.539 582.969L560.866 571.925V571.91L541.541 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.541 538.763L541.526 538.77V560.859L541.539 560.866L560.866 549.822V549.807L541.541 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 1036.08V1013.98L541.526 1025.03L560.866 1036.08Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 1013.98V991.876L541.526 1002.93L560.866 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 991.876V969.773L541.526 980.825L560.866 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 969.773V947.67L541.526 958.722L560.866 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 947.67V925.567L541.526 936.619L560.866 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 925.566V903.463L541.526 914.515L560.866 925.566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 903.463V881.36L541.526 892.412L560.866 903.463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 881.36V859.257L541.526 870.309L560.866 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 859.257V837.154L541.526 848.206L560.866 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 837.154V815.051L541.526 826.103L560.866 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 815.052V792.948L541.526 804.001L560.866 815.052Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 748.743V726.64L541.526 737.692L560.866 748.743Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 704.536V682.432L541.526 693.485L560.866 704.536Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 682.433V660.329L541.526 671.382L560.866 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 594.021V571.917L541.526 582.97L560.866 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 571.918V549.814L541.526 560.867L560.866 571.918Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 549.815V527.712L541.526 538.764L560.866 549.815Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_4497_42510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 1002.93L580.207 1002.93V1025.02L580.193 1025.03L560.866 1013.99V1013.97L580.192 1002.93Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 980.824L580.207 980.831V1002.92L580.193 1002.93L560.866 991.883V991.868L580.192 980.824Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 958.721L580.207 958.728V980.817L580.193 980.824L560.866 969.78V969.765L580.192 958.721Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 936.618L580.207 936.625V958.714L580.193 958.721L560.866 947.677V947.662L580.192 936.618Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 914.515L580.207 914.522V936.611L580.193 936.618L560.866 925.574V925.559L580.192 914.515Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 892.411L580.207 892.418V914.507L580.193 914.514L560.866 903.47V903.455L580.192 892.411Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 870.309L580.207 870.316V892.405L580.193 892.412L560.866 881.368V881.353L580.192 870.309Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 848.206L580.207 848.213V870.302L580.193 870.309L560.866 859.265V859.25L580.192 848.206Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 826.103L580.207 826.11V848.199L580.193 848.206L560.866 837.162V837.147L580.192 826.103Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 804L580.207 804.007V826.096L580.193 826.103L560.866 815.059V815.044L580.192 804Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 781.897L580.207 781.904V803.993L580.193 804L560.866 792.956V792.941L580.192 781.897Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 759.794L580.207 759.801V781.89L580.193 781.897L560.866 770.853V770.838L580.192 759.794Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 737.691L580.207 737.698V759.787L580.193 759.794L560.866 748.75V748.735L580.192 737.691Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 715.588L580.207 715.595V737.684L580.193 737.691L560.866 726.647V726.632L580.192 715.588Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 693.485L580.207 693.492V715.581L580.193 715.588L560.866 704.544V704.529L580.192 693.485Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 671.381L580.207 671.388V693.477L580.193 693.484L560.866 682.44V682.425L580.192 671.381Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 649.278L580.207 649.285V671.374L580.193 671.381L560.866 660.337V660.322L580.192 649.278Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 627.175L580.207 627.182V649.271L580.193 649.278L560.866 638.234V638.219L580.192 627.175Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 605.072L580.207 605.079V627.168L580.193 627.175L560.866 616.131V616.116L580.192 605.072Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 582.969L580.207 582.976V605.065L580.193 605.072L560.866 594.028V594.013L580.192 582.969Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 560.866L580.207 560.873V582.962L580.193 582.969L560.866 571.925V571.91L580.192 560.866Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 538.763L580.207 538.77V560.859L580.193 560.866L560.866 549.822V549.807L580.192 538.763Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 516.66L580.207 516.667V538.756L580.193 538.763L560.866 527.719V527.704L580.192 516.66Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 494.557L580.207 494.564V516.653L580.193 516.66L560.866 505.616V505.601L580.192 494.557Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 472.453L580.207 472.46V494.549L580.193 494.556L560.866 483.512V483.497L580.192 472.453Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 450.35L580.207 450.357V472.446L580.193 472.453L560.866 461.409V461.394L580.192 450.35Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 428.247L580.207 428.254V450.343L580.193 450.35L560.866 439.306V439.291L580.192 428.247Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 406.144L580.207 406.151V428.24L580.193 428.247L560.866 417.203V417.188L580.192 406.144Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 384.041L580.207 384.048V406.137L580.193 406.144L560.866 395.1V395.085L580.192 384.041Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 361.938L580.207 361.945V384.034L580.193 384.041L560.866 372.997V372.982L580.192 361.938Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.192 339.835L580.207 339.842V361.931L580.193 361.938L560.866 350.894V350.879L580.192 339.835Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 1036.08V1013.98L580.207 1025.03L560.866 1036.08Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 1013.98V991.876L580.207 1002.93L560.866 1013.98Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 991.876V969.773L580.207 980.825L560.866 991.876Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 969.773V947.67L580.207 958.722L560.866 969.773Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 947.67V925.567L580.207 936.619L560.866 947.67Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 925.567V903.464L580.207 914.516L560.866 925.567Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 903.463V881.36L580.207 892.412L560.866 903.463Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 881.36V859.257L580.207 870.309L560.866 881.36Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 859.257V837.154L580.207 848.206L560.866 859.257Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 837.154V815.051L580.207 826.103L560.866 837.154Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 815.052V792.948L580.207 804.001L560.866 815.052Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 792.949V770.845L580.207 781.898L560.866 792.949Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 770.846V748.743L580.207 759.795L560.866 770.846Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 748.743V726.64L580.207 737.692L560.866 748.743Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 726.64V704.536L580.207 715.589L560.866 726.64Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 704.536V682.432L580.207 693.485L560.866 704.536Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 682.433V660.329L580.207 671.382L560.866 682.433Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 660.33V638.227L580.207 649.279L560.866 660.33Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 638.227V616.124L580.207 627.176L560.866 638.227Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 616.124V594.021L580.207 605.073L560.866 616.124Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 594.021V571.917L580.207 582.97L560.866 594.021Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 571.918V549.814L580.207 560.867L560.866 571.918Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 549.815V527.711L580.207 538.764L560.866 549.815Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 505.608V483.505L580.207 494.558L560.866 505.608Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 461.402V439.298L580.207 450.351L560.866 461.402Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 439.299V417.195L580.207 428.248L560.866 439.299Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 417.196V395.092L580.207 406.145L560.866 417.196Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 395.092V372.989L580.207 384.042L560.866 395.092Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 372.99V350.886L580.207 361.939L560.866 372.99Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.866 350.886V328.783L580.207 339.836L560.866 350.886Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.3403 549.814L116.041 494.556M116.041 494.556V649.278M116.041 494.556L154.722 472.453M116.041 649.278L77.361 671.381V741.835V759.793L135.382 792.948V726.639M116.041 649.278L212.742 704.536M309.443 384.041L154.722 472.453M212.742 704.536L270.763 737.69V892.412L328.784 859.257M212.742 704.536V660.329M328.784 859.257V594.02L348.124 582.969M328.784 859.257L464.165 936.618V848.206M328.784 859.257L425.485 803.999V759.793M386.804 538.762L406.144 549.814L348.124 582.969M386.804 538.762L348.124 516.659L483.505 439.298M386.804 538.762V384.041L348.124 406.144M464.165 848.206L560.866 792.948V682.432M464.165 848.206V737.69L522.186 770.845M560.866 682.432L502.846 649.278V605.072L580.206 560.865V428.247L502.846 384.041V317.731M560.866 682.432L947.67 903.463M154.722 472.453V361.938L96.7012 395.783M348.124 582.969L212.742 505.608M348.124 582.969V649.278L406.144 616.123M212.742 505.608L174.062 527.711V571.917M212.742 505.608V549.814M425.485 759.793L386.804 737.69M425.485 759.793V671.381L464.165 649.278",
    stroke: "#DBF1C1",
    strokeWidth: 1.38144
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 295.628L154.722 207.907M0 295.628V-44.2068M0 295.628L77.3608 339.834M154.722 207.907L193.402 229.319V295.628L290.103 350.886L309.443 339.834M154.722 207.907V118.803M154.722 118.803L251.423 63.5457V129.855M154.722 118.803L77.3608 74.5973M386.804 295.628L444.825 262.474V218.267L541.526 163.01V30.3911L676.907 -46.9697M386.804 295.628V163.7M386.804 295.628L270.763 229.319M386.804 295.628L309.443 339.834M309.443 339.834V96.7004",
    stroke: "#DBF1C1",
    strokeWidth: 1.38144
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 612,
    height: 1024,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(19.3403 229.319)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(154.722 229.319)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(212.743 229.319)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(270.763 185.113)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(386.804 218.268)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(406.145 229.319)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(444.825 41.4424)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(483.505 218.268)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(0 -13.8154)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(58.0205 -168.537)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(77.3613 295.629)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(116.042 251.422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(96.7017 52.4941)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(135.382 -279.053)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(174.062 -35.918)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(193.402 450.35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(232.083 -234.847)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(251.423 361.938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(290.104 240.37)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(309.443 8.28809)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(328.784 240.37)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(348.124 251.422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(367.464 -312.207)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(464.165 549.814)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(502.846 417.195)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(522.186 -24.8672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(541.526 527.712)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_4497_42510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3402,
    height: 784.66,
    fill: "white",
    transform: "translate(560.866 328.783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/Referrals.2ed4e5cf6a854c4bdfe48a161ee4a15d.svg";
export { ForwardRef as ReactComponent };